(() => {
  if (window.CBPaymentSurchargeLoaded) return;
  window.CBPaymentSurchargeLoaded = true;

  const CARD_RATE = 0.10;
  const TRANSFER_RATE = 0.05;
  const FEE_VARIANTS = [
  {
    "id": 67674546241778,
    "cents": 5000
  },
  {
    "id": 50132195508466,
    "cents": 10000
  },
  {
    "id": 67674546274546,
    "cents": 15000
  },
  {
    "id": 67674546307314,
    "cents": 20000
  },
  {
    "id": 67674546340082,
    "cents": 25000
  },
  {
    "id": 67674546372850,
    "cents": 30000
  },
  {
    "id": 67674546405618,
    "cents": 35000
  },
  {
    "id": 67674546438386,
    "cents": 40000
  },
  {
    "id": 67674546471154,
    "cents": 45000
  },
  {
    "id": 67674546503922,
    "cents": 50000
  },
  {
    "id": 67674546536690,
    "cents": 55000
  },
  {
    "id": 67674546569458,
    "cents": 60000
  },
  {
    "id": 67674546602226,
    "cents": 65000
  },
  {
    "id": 67674546634994,
    "cents": 70000
  },
  {
    "id": 67674546667762,
    "cents": 75000
  },
  {
    "id": 67674546700530,
    "cents": 80000
  },
  {
    "id": 67674546733298,
    "cents": 85000
  },
  {
    "id": 67674546766066,
    "cents": 90000
  },
  {
    "id": 67674546798834,
    "cents": 95000
  },
  {
    "id": 50132195541234,
    "cents": 100000
  },
  {
    "id": 67674546831602,
    "cents": 105000
  },
  {
    "id": 67674546864370,
    "cents": 110000
  },
  {
    "id": 67674546897138,
    "cents": 115000
  },
  {
    "id": 67674546929906,
    "cents": 120000
  },
  {
    "id": 67674546962674,
    "cents": 125000
  },
  {
    "id": 67674546995442,
    "cents": 130000
  },
  {
    "id": 67674547028210,
    "cents": 135000
  },
  {
    "id": 67674547060978,
    "cents": 140000
  },
  {
    "id": 67674547093746,
    "cents": 145000
  },
  {
    "id": 67674547126514,
    "cents": 150000
  },
  {
    "id": 67674547159282,
    "cents": 155000
  },
  {
    "id": 67674547192050,
    "cents": 160000
  },
  {
    "id": 67674547224818,
    "cents": 165000
  },
  {
    "id": 67674547257586,
    "cents": 170000
  },
  {
    "id": 67674547290354,
    "cents": 175000
  },
  {
    "id": 67674547323122,
    "cents": 180000
  },
  {
    "id": 67674547355890,
    "cents": 185000
  },
  {
    "id": 67674547388658,
    "cents": 190000
  },
  {
    "id": 67674547421426,
    "cents": 195000
  },
  {
    "id": 67674547454194,
    "cents": 200000
  },
  {
    "id": 67674547486962,
    "cents": 205000
  },
  {
    "id": 67674547519730,
    "cents": 210000
  },
  {
    "id": 67674547552498,
    "cents": 215000
  },
  {
    "id": 67674547585266,
    "cents": 220000
  },
  {
    "id": 67674547618034,
    "cents": 225000
  },
  {
    "id": 67674547650802,
    "cents": 230000
  },
  {
    "id": 67674547683570,
    "cents": 235000
  },
  {
    "id": 67674547716338,
    "cents": 240000
  },
  {
    "id": 67674547749106,
    "cents": 245000
  },
  {
    "id": 67674547781874,
    "cents": 250000
  },
  {
    "id": 67674547814642,
    "cents": 255000
  },
  {
    "id": 67674547847410,
    "cents": 260000
  },
  {
    "id": 67674547880178,
    "cents": 265000
  },
  {
    "id": 67674547912946,
    "cents": 270000
  },
  {
    "id": 67674547945714,
    "cents": 275000
  },
  {
    "id": 67674547978482,
    "cents": 280000
  },
  {
    "id": 67674548011250,
    "cents": 285000
  },
  {
    "id": 67674548044018,
    "cents": 290000
  },
  {
    "id": 67674548076786,
    "cents": 295000
  },
  {
    "id": 67674548109554,
    "cents": 300000
  },
  {
    "id": 67674548142322,
    "cents": 305000
  },
  {
    "id": 67674548175090,
    "cents": 310000
  },
  {
    "id": 67674548207858,
    "cents": 315000
  },
  {
    "id": 67674548240626,
    "cents": 320000
  },
  {
    "id": 67674548273394,
    "cents": 325000
  },
  {
    "id": 67674548306162,
    "cents": 330000
  },
  {
    "id": 67674548338930,
    "cents": 335000
  },
  {
    "id": 67674548371698,
    "cents": 340000
  },
  {
    "id": 67674548404466,
    "cents": 345000
  },
  {
    "id": 67674548437234,
    "cents": 350000
  },
  {
    "id": 67674548470002,
    "cents": 355000
  },
  {
    "id": 67674548502770,
    "cents": 360000
  },
  {
    "id": 67674548535538,
    "cents": 365000
  },
  {
    "id": 67674548568306,
    "cents": 370000
  },
  {
    "id": 67674548601074,
    "cents": 375000
  },
  {
    "id": 67674548633842,
    "cents": 380000
  },
  {
    "id": 67674548666610,
    "cents": 385000
  },
  {
    "id": 67674548699378,
    "cents": 390000
  },
  {
    "id": 67674548732146,
    "cents": 395000
  },
  {
    "id": 67674548764914,
    "cents": 400000
  },
  {
    "id": 67674548797682,
    "cents": 405000
  },
  {
    "id": 67674548830450,
    "cents": 410000
  },
  {
    "id": 67674548863218,
    "cents": 415000
  },
  {
    "id": 67674548895986,
    "cents": 420000
  },
  {
    "id": 67674548928754,
    "cents": 425000
  },
  {
    "id": 67674548961522,
    "cents": 430000
  },
  {
    "id": 67674548994290,
    "cents": 435000
  },
  {
    "id": 67674549027058,
    "cents": 440000
  },
  {
    "id": 67674549059826,
    "cents": 445000
  },
  {
    "id": 67674549092594,
    "cents": 450000
  },
  {
    "id": 67674549125362,
    "cents": 455000
  },
  {
    "id": 67674549158130,
    "cents": 460000
  },
  {
    "id": 67674549190898,
    "cents": 465000
  },
  {
    "id": 67674549223666,
    "cents": 470000
  },
  {
    "id": 67674549256434,
    "cents": 475000
  },
  {
    "id": 67674549289202,
    "cents": 480000
  },
  {
    "id": 67674549321970,
    "cents": 485000
  },
  {
    "id": 67674549354738,
    "cents": 490000
  },
  {
    "id": 67674549387506,
    "cents": 495000
  },
  {
    "id": 67674549420274,
    "cents": 500000
  },
  {
    "id": 67674549453042,
    "cents": 505000
  },
  {
    "id": 67674549485810,
    "cents": 510000
  },
  {
    "id": 67674549518578,
    "cents": 515000
  },
  {
    "id": 67674549551346,
    "cents": 520000
  },
  {
    "id": 67674549584114,
    "cents": 525000
  },
  {
    "id": 67674549616882,
    "cents": 530000
  },
  {
    "id": 67674549649650,
    "cents": 535000
  },
  {
    "id": 67674549682418,
    "cents": 540000
  },
  {
    "id": 67674549715186,
    "cents": 545000
  },
  {
    "id": 67674549747954,
    "cents": 550000
  },
  {
    "id": 67674549780722,
    "cents": 555000
  },
  {
    "id": 67674549813490,
    "cents": 560000
  },
  {
    "id": 67674549846258,
    "cents": 565000
  },
  {
    "id": 67674549879026,
    "cents": 570000
  },
  {
    "id": 67674549911794,
    "cents": 575000
  },
  {
    "id": 67674549944562,
    "cents": 580000
  },
  {
    "id": 67674549977330,
    "cents": 585000
  },
  {
    "id": 67674550010098,
    "cents": 590000
  },
  {
    "id": 67674550042866,
    "cents": 595000
  },
  {
    "id": 67674550075634,
    "cents": 600000
  },
  {
    "id": 67674550108402,
    "cents": 605000
  },
  {
    "id": 67674550141170,
    "cents": 610000
  },
  {
    "id": 67674550173938,
    "cents": 615000
  },
  {
    "id": 67674550206706,
    "cents": 620000
  },
  {
    "id": 67674550239474,
    "cents": 625000
  },
  {
    "id": 67674550272242,
    "cents": 630000
  },
  {
    "id": 67674550305010,
    "cents": 635000
  },
  {
    "id": 67674550337778,
    "cents": 640000
  },
  {
    "id": 67674550370546,
    "cents": 645000
  },
  {
    "id": 67674550403314,
    "cents": 650000
  },
  {
    "id": 67674550436082,
    "cents": 655000
  },
  {
    "id": 67674550468850,
    "cents": 660000
  },
  {
    "id": 67674550501618,
    "cents": 665000
  },
  {
    "id": 67674550534386,
    "cents": 670000
  },
  {
    "id": 67674550567154,
    "cents": 675000
  },
  {
    "id": 67674550599922,
    "cents": 680000
  },
  {
    "id": 67674550632690,
    "cents": 685000
  },
  {
    "id": 67674550665458,
    "cents": 690000
  },
  {
    "id": 67674550698226,
    "cents": 695000
  },
  {
    "id": 67674550730994,
    "cents": 700000
  },
  {
    "id": 67674550763762,
    "cents": 705000
  },
  {
    "id": 67674550796530,
    "cents": 710000
  },
  {
    "id": 67674550829298,
    "cents": 715000
  },
  {
    "id": 67674550862066,
    "cents": 720000
  },
  {
    "id": 67674550894834,
    "cents": 725000
  },
  {
    "id": 67674550927602,
    "cents": 730000
  },
  {
    "id": 67674550960370,
    "cents": 735000
  },
  {
    "id": 67674550993138,
    "cents": 740000
  },
  {
    "id": 67674551025906,
    "cents": 745000
  },
  {
    "id": 67674551058674,
    "cents": 750000
  },
  {
    "id": 67674551091442,
    "cents": 755000
  },
  {
    "id": 67674551124210,
    "cents": 760000
  },
  {
    "id": 67674551156978,
    "cents": 765000
  },
  {
    "id": 67674551189746,
    "cents": 770000
  },
  {
    "id": 67674551222514,
    "cents": 775000
  },
  {
    "id": 67674551255282,
    "cents": 780000
  },
  {
    "id": 67674551288050,
    "cents": 785000
  },
  {
    "id": 67674551320818,
    "cents": 790000
  },
  {
    "id": 67674551353586,
    "cents": 795000
  },
  {
    "id": 67674551386354,
    "cents": 800000
  },
  {
    "id": 67674551419122,
    "cents": 805000
  },
  {
    "id": 67674551451890,
    "cents": 810000
  },
  {
    "id": 67674551484658,
    "cents": 815000
  },
  {
    "id": 67674551517426,
    "cents": 820000
  },
  {
    "id": 67674551550194,
    "cents": 825000
  },
  {
    "id": 67674551582962,
    "cents": 830000
  },
  {
    "id": 67674551615730,
    "cents": 835000
  },
  {
    "id": 67674551648498,
    "cents": 840000
  },
  {
    "id": 67674551681266,
    "cents": 845000
  },
  {
    "id": 67674551714034,
    "cents": 850000
  },
  {
    "id": 67674551746802,
    "cents": 855000
  },
  {
    "id": 67674551779570,
    "cents": 860000
  },
  {
    "id": 67674551812338,
    "cents": 865000
  },
  {
    "id": 67674551845106,
    "cents": 870000
  },
  {
    "id": 67674551877874,
    "cents": 875000
  },
  {
    "id": 67674551910642,
    "cents": 880000
  },
  {
    "id": 67674551943410,
    "cents": 885000
  },
  {
    "id": 67674551976178,
    "cents": 890000
  },
  {
    "id": 67674552008946,
    "cents": 895000
  },
  {
    "id": 67674552041714,
    "cents": 900000
  },
  {
    "id": 67674552074482,
    "cents": 905000
  },
  {
    "id": 67674552107250,
    "cents": 910000
  },
  {
    "id": 67674552140018,
    "cents": 915000
  },
  {
    "id": 67674552172786,
    "cents": 920000
  },
  {
    "id": 67674552205554,
    "cents": 925000
  },
  {
    "id": 67674552238322,
    "cents": 930000
  },
  {
    "id": 67674552271090,
    "cents": 935000
  },
  {
    "id": 67674552303858,
    "cents": 940000
  },
  {
    "id": 67674552336626,
    "cents": 945000
  },
  {
    "id": 67674552369394,
    "cents": 950000
  },
  {
    "id": 67674552402162,
    "cents": 955000
  },
  {
    "id": 67674552434930,
    "cents": 960000
  },
  {
    "id": 67674552467698,
    "cents": 965000
  },
  {
    "id": 67674552500466,
    "cents": 970000
  },
  {
    "id": 67674552533234,
    "cents": 975000
  },
  {
    "id": 67674552566002,
    "cents": 980000
  },
  {
    "id": 67674552598770,
    "cents": 985000
  },
  {
    "id": 67674552631538,
    "cents": 990000
  },
  {
    "id": 67674552664306,
    "cents": 995000
  },
  {
    "id": 50132195574002,
    "cents": 1000000
  },
  {
    "id": 67674552697074,
    "cents": 1005000
  },
  {
    "id": 67674552729842,
    "cents": 1010000
  },
  {
    "id": 67674552762610,
    "cents": 1015000
  },
  {
    "id": 67674552926450,
    "cents": 1020000
  },
  {
    "id": 67674552959218,
    "cents": 1025000
  },
  {
    "id": 67674552991986,
    "cents": 1030000
  },
  {
    "id": 67674553024754,
    "cents": 1035000
  },
  {
    "id": 67674553057522,
    "cents": 1040000
  },
  {
    "id": 67674553090290,
    "cents": 1045000
  },
  {
    "id": 67674553123058,
    "cents": 1050000
  },
  {
    "id": 67674553155826,
    "cents": 1055000
  },
  {
    "id": 67674553188594,
    "cents": 1060000
  },
  {
    "id": 67674553221362,
    "cents": 1065000
  },
  {
    "id": 67674553254130,
    "cents": 1070000
  },
  {
    "id": 67674553286898,
    "cents": 1075000
  },
  {
    "id": 67674553319666,
    "cents": 1080000
  },
  {
    "id": 67674553352434,
    "cents": 1085000
  },
  {
    "id": 67674553385202,
    "cents": 1090000
  },
  {
    "id": 67674553417970,
    "cents": 1095000
  },
  {
    "id": 67674553450738,
    "cents": 1100000
  },
  {
    "id": 67674553483506,
    "cents": 1105000
  },
  {
    "id": 67674553516274,
    "cents": 1110000
  },
  {
    "id": 67674553549042,
    "cents": 1115000
  },
  {
    "id": 67674553581810,
    "cents": 1120000
  },
  {
    "id": 67674553614578,
    "cents": 1125000
  },
  {
    "id": 67674553647346,
    "cents": 1130000
  },
  {
    "id": 67674553680114,
    "cents": 1135000
  },
  {
    "id": 67674553712882,
    "cents": 1140000
  },
  {
    "id": 67674553745650,
    "cents": 1145000
  },
  {
    "id": 67674553778418,
    "cents": 1150000
  },
  {
    "id": 67674553811186,
    "cents": 1155000
  },
  {
    "id": 67674553843954,
    "cents": 1160000
  },
  {
    "id": 67674553876722,
    "cents": 1165000
  },
  {
    "id": 67674553909490,
    "cents": 1170000
  },
  {
    "id": 67674553942258,
    "cents": 1175000
  },
  {
    "id": 67674553975026,
    "cents": 1180000
  },
  {
    "id": 67674554007794,
    "cents": 1185000
  },
  {
    "id": 67674554040562,
    "cents": 1190000
  },
  {
    "id": 67674554073330,
    "cents": 1195000
  },
  {
    "id": 67674554106098,
    "cents": 1200000
  },
  {
    "id": 67674554138866,
    "cents": 1205000
  },
  {
    "id": 67674554171634,
    "cents": 1210000
  },
  {
    "id": 67674554204402,
    "cents": 1215000
  },
  {
    "id": 67674554237170,
    "cents": 1220000
  },
  {
    "id": 67674554269938,
    "cents": 1225000
  },
  {
    "id": 67674554302706,
    "cents": 1230000
  },
  {
    "id": 67674554335474,
    "cents": 1235000
  },
  {
    "id": 67674554368242,
    "cents": 1240000
  },
  {
    "id": 67674554401010,
    "cents": 1245000
  },
  {
    "id": 67674554433778,
    "cents": 1250000
  },
  {
    "id": 67674554466546,
    "cents": 1255000
  },
  {
    "id": 67674554499314,
    "cents": 1260000
  },
  {
    "id": 67674554532082,
    "cents": 1265000
  },
  {
    "id": 67674554564850,
    "cents": 1270000
  },
  {
    "id": 67674554597618,
    "cents": 1275000
  },
  {
    "id": 67674554630386,
    "cents": 1280000
  },
  {
    "id": 67674554663154,
    "cents": 1285000
  },
  {
    "id": 67674554695922,
    "cents": 1290000
  },
  {
    "id": 67674554728690,
    "cents": 1295000
  },
  {
    "id": 67674554761458,
    "cents": 1300000
  },
  {
    "id": 67674554794226,
    "cents": 1305000
  },
  {
    "id": 67674554826994,
    "cents": 1310000
  },
  {
    "id": 67674554859762,
    "cents": 1315000
  },
  {
    "id": 67674554892530,
    "cents": 1320000
  },
  {
    "id": 67674554925298,
    "cents": 1325000
  },
  {
    "id": 67674554958066,
    "cents": 1330000
  },
  {
    "id": 67674554990834,
    "cents": 1335000
  },
  {
    "id": 67674555023602,
    "cents": 1340000
  },
  {
    "id": 67674555056370,
    "cents": 1345000
  },
  {
    "id": 67674555089138,
    "cents": 1350000
  },
  {
    "id": 67674555121906,
    "cents": 1355000
  },
  {
    "id": 67674555154674,
    "cents": 1360000
  },
  {
    "id": 67674555187442,
    "cents": 1365000
  },
  {
    "id": 67674555220210,
    "cents": 1370000
  },
  {
    "id": 67674555252978,
    "cents": 1375000
  },
  {
    "id": 67674555285746,
    "cents": 1380000
  },
  {
    "id": 67674555318514,
    "cents": 1385000
  },
  {
    "id": 67674555351282,
    "cents": 1390000
  },
  {
    "id": 67674555384050,
    "cents": 1395000
  },
  {
    "id": 67674555416818,
    "cents": 1400000
  },
  {
    "id": 67674555449586,
    "cents": 1405000
  },
  {
    "id": 67674555482354,
    "cents": 1410000
  },
  {
    "id": 67674555515122,
    "cents": 1415000
  },
  {
    "id": 67674555547890,
    "cents": 1420000
  },
  {
    "id": 67674555580658,
    "cents": 1425000
  },
  {
    "id": 67674555613426,
    "cents": 1430000
  },
  {
    "id": 67674555646194,
    "cents": 1435000
  },
  {
    "id": 67674555678962,
    "cents": 1440000
  },
  {
    "id": 67674555711730,
    "cents": 1445000
  },
  {
    "id": 67674555744498,
    "cents": 1450000
  },
  {
    "id": 67674555777266,
    "cents": 1455000
  },
  {
    "id": 67674555810034,
    "cents": 1460000
  },
  {
    "id": 67674555842802,
    "cents": 1465000
  },
  {
    "id": 67674555875570,
    "cents": 1470000
  },
  {
    "id": 67674555908338,
    "cents": 1475000
  },
  {
    "id": 67674555941106,
    "cents": 1480000
  },
  {
    "id": 67674555973874,
    "cents": 1485000
  },
  {
    "id": 67674556006642,
    "cents": 1490000
  },
  {
    "id": 67674556039410,
    "cents": 1495000
  },
  {
    "id": 67674556072178,
    "cents": 1500000
  },
  {
    "id": 67674556104946,
    "cents": 1505000
  },
  {
    "id": 67674556137714,
    "cents": 1510000
  },
  {
    "id": 67674556170482,
    "cents": 1515000
  },
  {
    "id": 67674556203250,
    "cents": 1520000
  },
  {
    "id": 67674556236018,
    "cents": 1525000
  },
  {
    "id": 67674556268786,
    "cents": 1530000
  },
  {
    "id": 67674556301554,
    "cents": 1535000
  },
  {
    "id": 67674556334322,
    "cents": 1540000
  },
  {
    "id": 67674556367090,
    "cents": 1545000
  },
  {
    "id": 67674556399858,
    "cents": 1550000
  },
  {
    "id": 67674556432626,
    "cents": 1555000
  },
  {
    "id": 67674556465394,
    "cents": 1560000
  },
  {
    "id": 67674556498162,
    "cents": 1565000
  },
  {
    "id": 67674556530930,
    "cents": 1570000
  },
  {
    "id": 67674556563698,
    "cents": 1575000
  },
  {
    "id": 67674556596466,
    "cents": 1580000
  },
  {
    "id": 67674556629234,
    "cents": 1585000
  },
  {
    "id": 67674556662002,
    "cents": 1590000
  },
  {
    "id": 67674556694770,
    "cents": 1595000
  },
  {
    "id": 67674556727538,
    "cents": 1600000
  },
  {
    "id": 67674556760306,
    "cents": 1605000
  },
  {
    "id": 67674556793074,
    "cents": 1610000
  },
  {
    "id": 67674556825842,
    "cents": 1615000
  },
  {
    "id": 67674556858610,
    "cents": 1620000
  },
  {
    "id": 67674556891378,
    "cents": 1625000
  },
  {
    "id": 67674556924146,
    "cents": 1630000
  },
  {
    "id": 67674556956914,
    "cents": 1635000
  },
  {
    "id": 67674556989682,
    "cents": 1640000
  },
  {
    "id": 67674557022450,
    "cents": 1645000
  },
  {
    "id": 67674557055218,
    "cents": 1650000
  },
  {
    "id": 67674557087986,
    "cents": 1655000
  },
  {
    "id": 67674557120754,
    "cents": 1660000
  },
  {
    "id": 67674557153522,
    "cents": 1665000
  },
  {
    "id": 67674557186290,
    "cents": 1670000
  },
  {
    "id": 67674557219058,
    "cents": 1675000
  },
  {
    "id": 67674557251826,
    "cents": 1680000
  },
  {
    "id": 67674557284594,
    "cents": 1685000
  },
  {
    "id": 67674557317362,
    "cents": 1690000
  },
  {
    "id": 67674557350130,
    "cents": 1695000
  },
  {
    "id": 67674557382898,
    "cents": 1700000
  },
  {
    "id": 67674557415666,
    "cents": 1705000
  },
  {
    "id": 67674557448434,
    "cents": 1710000
  },
  {
    "id": 67674557481202,
    "cents": 1715000
  },
  {
    "id": 67674557513970,
    "cents": 1720000
  },
  {
    "id": 67674557546738,
    "cents": 1725000
  },
  {
    "id": 67674557579506,
    "cents": 1730000
  },
  {
    "id": 67674557612274,
    "cents": 1735000
  },
  {
    "id": 67674557645042,
    "cents": 1740000
  },
  {
    "id": 67674557677810,
    "cents": 1745000
  },
  {
    "id": 67674557710578,
    "cents": 1750000
  },
  {
    "id": 67674557743346,
    "cents": 1755000
  },
  {
    "id": 67674557776114,
    "cents": 1760000
  },
  {
    "id": 67674557808882,
    "cents": 1765000
  },
  {
    "id": 67674557841650,
    "cents": 1770000
  },
  {
    "id": 67674557874418,
    "cents": 1775000
  },
  {
    "id": 67674557907186,
    "cents": 1780000
  },
  {
    "id": 67674557939954,
    "cents": 1785000
  },
  {
    "id": 67674557972722,
    "cents": 1790000
  },
  {
    "id": 67674558005490,
    "cents": 1795000
  },
  {
    "id": 67674558038258,
    "cents": 1800000
  },
  {
    "id": 67674558071026,
    "cents": 1805000
  },
  {
    "id": 67674558103794,
    "cents": 1810000
  },
  {
    "id": 67674558136562,
    "cents": 1815000
  },
  {
    "id": 67674558169330,
    "cents": 1820000
  },
  {
    "id": 67674558202098,
    "cents": 1825000
  },
  {
    "id": 67674558234866,
    "cents": 1830000
  },
  {
    "id": 67674558267634,
    "cents": 1835000
  },
  {
    "id": 67674558300402,
    "cents": 1840000
  },
  {
    "id": 67674558333170,
    "cents": 1845000
  },
  {
    "id": 67674558365938,
    "cents": 1850000
  },
  {
    "id": 67674558398706,
    "cents": 1855000
  },
  {
    "id": 67674558431474,
    "cents": 1860000
  },
  {
    "id": 67674558464242,
    "cents": 1865000
  },
  {
    "id": 67674558497010,
    "cents": 1870000
  },
  {
    "id": 67674558529778,
    "cents": 1875000
  },
  {
    "id": 67674558562546,
    "cents": 1880000
  },
  {
    "id": 67674558595314,
    "cents": 1885000
  },
  {
    "id": 67674558628082,
    "cents": 1890000
  },
  {
    "id": 67674558660850,
    "cents": 1895000
  },
  {
    "id": 67674558693618,
    "cents": 1900000
  },
  {
    "id": 67674558726386,
    "cents": 1905000
  },
  {
    "id": 67674558759154,
    "cents": 1910000
  },
  {
    "id": 67674558791922,
    "cents": 1915000
  },
  {
    "id": 67674558824690,
    "cents": 1920000
  },
  {
    "id": 67674558857458,
    "cents": 1925000
  },
  {
    "id": 67674558890226,
    "cents": 1930000
  },
  {
    "id": 67674558922994,
    "cents": 1935000
  },
  {
    "id": 67674558955762,
    "cents": 1940000
  },
  {
    "id": 67674558988530,
    "cents": 1945000
  },
  {
    "id": 67674559021298,
    "cents": 1950000
  },
  {
    "id": 67674559054066,
    "cents": 1955000
  },
  {
    "id": 67674559086834,
    "cents": 1960000
  },
  {
    "id": 67674559119602,
    "cents": 1965000
  },
  {
    "id": 67674559152370,
    "cents": 1970000
  },
  {
    "id": 67674559185138,
    "cents": 1975000
  },
  {
    "id": 67674559217906,
    "cents": 1980000
  },
  {
    "id": 67674559250674,
    "cents": 1985000
  },
  {
    "id": 67674559283442,
    "cents": 1990000
  },
  {
    "id": 67674559316210,
    "cents": 1995000
  },
  {
    "id": 67674559348978,
    "cents": 2000000
  },
  {
    "id": 67674559381746,
    "cents": 2005000
  },
  {
    "id": 67674559414514,
    "cents": 2010000
  },
  {
    "id": 67674559447282,
    "cents": 2015000
  },
  {
    "id": 67674559840498,
    "cents": 2020000
  },
  {
    "id": 67674559873266,
    "cents": 2025000
  },
  {
    "id": 67674559906034,
    "cents": 2030000
  },
  {
    "id": 67674559938802,
    "cents": 2035000
  },
  {
    "id": 67674559971570,
    "cents": 2040000
  },
  {
    "id": 67674560004338,
    "cents": 2045000
  },
  {
    "id": 67674560037106,
    "cents": 2050000
  },
  {
    "id": 67674560069874,
    "cents": 2055000
  },
  {
    "id": 67674560102642,
    "cents": 2060000
  },
  {
    "id": 67674560135410,
    "cents": 2065000
  },
  {
    "id": 67674560168178,
    "cents": 2070000
  },
  {
    "id": 67674560200946,
    "cents": 2075000
  },
  {
    "id": 67674560233714,
    "cents": 2080000
  },
  {
    "id": 67674560266482,
    "cents": 2085000
  },
  {
    "id": 67674560299250,
    "cents": 2090000
  },
  {
    "id": 67674560332018,
    "cents": 2095000
  },
  {
    "id": 67674560364786,
    "cents": 2100000
  },
  {
    "id": 67674560397554,
    "cents": 2105000
  },
  {
    "id": 67674560430322,
    "cents": 2110000
  },
  {
    "id": 67674560463090,
    "cents": 2115000
  },
  {
    "id": 67674560495858,
    "cents": 2120000
  },
  {
    "id": 67674560528626,
    "cents": 2125000
  },
  {
    "id": 67674560561394,
    "cents": 2130000
  },
  {
    "id": 67674560594162,
    "cents": 2135000
  },
  {
    "id": 67674560626930,
    "cents": 2140000
  },
  {
    "id": 67674560659698,
    "cents": 2145000
  },
  {
    "id": 67674560692466,
    "cents": 2150000
  },
  {
    "id": 67674560725234,
    "cents": 2155000
  },
  {
    "id": 67674560758002,
    "cents": 2160000
  },
  {
    "id": 67674560790770,
    "cents": 2165000
  },
  {
    "id": 67674560823538,
    "cents": 2170000
  },
  {
    "id": 67674560856306,
    "cents": 2175000
  },
  {
    "id": 67674560889074,
    "cents": 2180000
  },
  {
    "id": 67674560921842,
    "cents": 2185000
  },
  {
    "id": 67674560954610,
    "cents": 2190000
  },
  {
    "id": 67674560987378,
    "cents": 2195000
  },
  {
    "id": 67674561020146,
    "cents": 2200000
  },
  {
    "id": 67674561052914,
    "cents": 2205000
  },
  {
    "id": 67674561085682,
    "cents": 2210000
  },
  {
    "id": 67674561118450,
    "cents": 2215000
  },
  {
    "id": 67674561151218,
    "cents": 2220000
  },
  {
    "id": 67674561183986,
    "cents": 2225000
  },
  {
    "id": 67674561216754,
    "cents": 2230000
  },
  {
    "id": 67674561249522,
    "cents": 2235000
  },
  {
    "id": 67674561282290,
    "cents": 2240000
  },
  {
    "id": 67674561315058,
    "cents": 2245000
  },
  {
    "id": 67674561347826,
    "cents": 2250000
  },
  {
    "id": 67674561380594,
    "cents": 2255000
  },
  {
    "id": 67674561413362,
    "cents": 2260000
  },
  {
    "id": 67674561446130,
    "cents": 2265000
  },
  {
    "id": 67674561478898,
    "cents": 2270000
  },
  {
    "id": 67674561511666,
    "cents": 2275000
  },
  {
    "id": 67674561544434,
    "cents": 2280000
  },
  {
    "id": 67674561577202,
    "cents": 2285000
  },
  {
    "id": 67674561609970,
    "cents": 2290000
  },
  {
    "id": 67674561642738,
    "cents": 2295000
  },
  {
    "id": 67674561675506,
    "cents": 2300000
  },
  {
    "id": 67674561708274,
    "cents": 2305000
  },
  {
    "id": 67674561741042,
    "cents": 2310000
  },
  {
    "id": 67674561773810,
    "cents": 2315000
  },
  {
    "id": 67674561806578,
    "cents": 2320000
  },
  {
    "id": 67674561839346,
    "cents": 2325000
  },
  {
    "id": 67674561872114,
    "cents": 2330000
  },
  {
    "id": 67674561904882,
    "cents": 2335000
  },
  {
    "id": 67674561937650,
    "cents": 2340000
  },
  {
    "id": 67674561970418,
    "cents": 2345000
  },
  {
    "id": 67674562003186,
    "cents": 2350000
  },
  {
    "id": 67674562035954,
    "cents": 2355000
  },
  {
    "id": 67674562068722,
    "cents": 2360000
  },
  {
    "id": 67674562101490,
    "cents": 2365000
  },
  {
    "id": 67674562134258,
    "cents": 2370000
  },
  {
    "id": 67674562167026,
    "cents": 2375000
  },
  {
    "id": 67674562199794,
    "cents": 2380000
  },
  {
    "id": 67674562232562,
    "cents": 2385000
  },
  {
    "id": 67674562265330,
    "cents": 2390000
  },
  {
    "id": 67674562298098,
    "cents": 2395000
  },
  {
    "id": 67674562330866,
    "cents": 2400000
  },
  {
    "id": 67674562363634,
    "cents": 2405000
  },
  {
    "id": 67674562396402,
    "cents": 2410000
  },
  {
    "id": 67674562429170,
    "cents": 2415000
  },
  {
    "id": 67674562461938,
    "cents": 2420000
  },
  {
    "id": 67674562494706,
    "cents": 2425000
  },
  {
    "id": 67674562527474,
    "cents": 2430000
  },
  {
    "id": 67674562560242,
    "cents": 2435000
  },
  {
    "id": 67674562593010,
    "cents": 2440000
  },
  {
    "id": 67674562625778,
    "cents": 2445000
  },
  {
    "id": 67674562658546,
    "cents": 2450000
  },
  {
    "id": 67674562691314,
    "cents": 2455000
  },
  {
    "id": 67674562724082,
    "cents": 2460000
  },
  {
    "id": 67674562756850,
    "cents": 2465000
  },
  {
    "id": 67674562789618,
    "cents": 2470000
  },
  {
    "id": 67674562822386,
    "cents": 2475000
  },
  {
    "id": 67674562855154,
    "cents": 2480000
  },
  {
    "id": 67674562887922,
    "cents": 2485000
  },
  {
    "id": 67674562920690,
    "cents": 2490000
  },
  {
    "id": 67674562953458,
    "cents": 2495000
  },
  {
    "id": 67674562986226,
    "cents": 2500000
  },
  {
    "id": 67674563018994,
    "cents": 2505000
  },
  {
    "id": 67674563051762,
    "cents": 2510000
  },
  {
    "id": 67674563084530,
    "cents": 2515000
  },
  {
    "id": 67674563117298,
    "cents": 2520000
  },
  {
    "id": 67674563150066,
    "cents": 2525000
  },
  {
    "id": 67674563182834,
    "cents": 2530000
  },
  {
    "id": 67674563215602,
    "cents": 2535000
  },
  {
    "id": 67674563248370,
    "cents": 2540000
  },
  {
    "id": 67674563281138,
    "cents": 2545000
  },
  {
    "id": 67674563313906,
    "cents": 2550000
  },
  {
    "id": 67674563346674,
    "cents": 2555000
  },
  {
    "id": 67674563379442,
    "cents": 2560000
  },
  {
    "id": 67674563412210,
    "cents": 2565000
  },
  {
    "id": 67674563444978,
    "cents": 2570000
  },
  {
    "id": 67674563477746,
    "cents": 2575000
  },
  {
    "id": 67674563510514,
    "cents": 2580000
  },
  {
    "id": 67674563543282,
    "cents": 2585000
  },
  {
    "id": 67674563576050,
    "cents": 2590000
  },
  {
    "id": 67674563608818,
    "cents": 2595000
  },
  {
    "id": 67674563641586,
    "cents": 2600000
  },
  {
    "id": 67674563674354,
    "cents": 2605000
  },
  {
    "id": 67674563707122,
    "cents": 2610000
  },
  {
    "id": 67674563739890,
    "cents": 2615000
  },
  {
    "id": 67674563772658,
    "cents": 2620000
  },
  {
    "id": 67674563805426,
    "cents": 2625000
  },
  {
    "id": 67674563838194,
    "cents": 2630000
  },
  {
    "id": 67674563870962,
    "cents": 2635000
  },
  {
    "id": 67674563903730,
    "cents": 2640000
  },
  {
    "id": 67674563936498,
    "cents": 2645000
  },
  {
    "id": 67674563969266,
    "cents": 2650000
  },
  {
    "id": 67674564002034,
    "cents": 2655000
  },
  {
    "id": 67674564034802,
    "cents": 2660000
  },
  {
    "id": 67674564067570,
    "cents": 2665000
  },
  {
    "id": 67674564100338,
    "cents": 2670000
  },
  {
    "id": 67674564133106,
    "cents": 2675000
  },
  {
    "id": 67674564165874,
    "cents": 2680000
  },
  {
    "id": 67674564198642,
    "cents": 2685000
  },
  {
    "id": 67674564231410,
    "cents": 2690000
  },
  {
    "id": 67674564264178,
    "cents": 2695000
  },
  {
    "id": 67674564296946,
    "cents": 2700000
  },
  {
    "id": 67674564329714,
    "cents": 2705000
  },
  {
    "id": 67674564362482,
    "cents": 2710000
  },
  {
    "id": 67674564395250,
    "cents": 2715000
  },
  {
    "id": 67674564428018,
    "cents": 2720000
  },
  {
    "id": 67674564460786,
    "cents": 2725000
  },
  {
    "id": 67674564493554,
    "cents": 2730000
  },
  {
    "id": 67674564526322,
    "cents": 2735000
  },
  {
    "id": 67674564559090,
    "cents": 2740000
  },
  {
    "id": 67674564591858,
    "cents": 2745000
  },
  {
    "id": 67674564624626,
    "cents": 2750000
  },
  {
    "id": 67674564657394,
    "cents": 2755000
  },
  {
    "id": 67674564690162,
    "cents": 2760000
  },
  {
    "id": 67674564722930,
    "cents": 2765000
  },
  {
    "id": 67674564755698,
    "cents": 2770000
  },
  {
    "id": 67674564788466,
    "cents": 2775000
  },
  {
    "id": 67674564821234,
    "cents": 2780000
  },
  {
    "id": 67674564854002,
    "cents": 2785000
  },
  {
    "id": 67674564886770,
    "cents": 2790000
  },
  {
    "id": 67674564919538,
    "cents": 2795000
  },
  {
    "id": 67674564952306,
    "cents": 2800000
  },
  {
    "id": 67674564985074,
    "cents": 2805000
  },
  {
    "id": 67674565017842,
    "cents": 2810000
  },
  {
    "id": 67674565050610,
    "cents": 2815000
  },
  {
    "id": 67674565083378,
    "cents": 2820000
  },
  {
    "id": 67674565116146,
    "cents": 2825000
  },
  {
    "id": 67674565148914,
    "cents": 2830000
  },
  {
    "id": 67674565181682,
    "cents": 2835000
  },
  {
    "id": 67674565214450,
    "cents": 2840000
  },
  {
    "id": 67674565247218,
    "cents": 2845000
  },
  {
    "id": 67674565279986,
    "cents": 2850000
  },
  {
    "id": 67674565312754,
    "cents": 2855000
  },
  {
    "id": 67674565345522,
    "cents": 2860000
  },
  {
    "id": 67674565378290,
    "cents": 2865000
  },
  {
    "id": 67674565411058,
    "cents": 2870000
  },
  {
    "id": 67674565443826,
    "cents": 2875000
  },
  {
    "id": 67674565476594,
    "cents": 2880000
  },
  {
    "id": 67674565509362,
    "cents": 2885000
  },
  {
    "id": 67674565542130,
    "cents": 2890000
  },
  {
    "id": 67674565574898,
    "cents": 2895000
  },
  {
    "id": 67674565607666,
    "cents": 2900000
  },
  {
    "id": 67674565640434,
    "cents": 2905000
  },
  {
    "id": 67674565673202,
    "cents": 2910000
  },
  {
    "id": 67674565705970,
    "cents": 2915000
  },
  {
    "id": 67674565738738,
    "cents": 2920000
  },
  {
    "id": 67674565771506,
    "cents": 2925000
  },
  {
    "id": 67674565804274,
    "cents": 2930000
  },
  {
    "id": 67674565837042,
    "cents": 2935000
  },
  {
    "id": 67674565869810,
    "cents": 2940000
  },
  {
    "id": 67674565902578,
    "cents": 2945000
  },
  {
    "id": 67674565935346,
    "cents": 2950000
  },
  {
    "id": 67674565968114,
    "cents": 2955000
  },
  {
    "id": 67674566000882,
    "cents": 2960000
  },
  {
    "id": 67674566033650,
    "cents": 2965000
  },
  {
    "id": 67674566066418,
    "cents": 2970000
  },
  {
    "id": 67674566099186,
    "cents": 2975000
  },
  {
    "id": 67674566131954,
    "cents": 2980000
  },
  {
    "id": 67674566164722,
    "cents": 2985000
  },
  {
    "id": 67674566197490,
    "cents": 2990000
  },
  {
    "id": 67674566230258,
    "cents": 2995000
  },
  {
    "id": 67674566263026,
    "cents": 3000000
  },
  {
    "id": 67674566295794,
    "cents": 3005000
  },
  {
    "id": 67674566328562,
    "cents": 3010000
  },
  {
    "id": 67674566361330,
    "cents": 3015000
  },
  {
    "id": 67674566656242,
    "cents": 3020000
  },
  {
    "id": 67674566689010,
    "cents": 3025000
  },
  {
    "id": 67674566721778,
    "cents": 3030000
  },
  {
    "id": 67674566754546,
    "cents": 3035000
  },
  {
    "id": 67674566787314,
    "cents": 3040000
  },
  {
    "id": 67674566820082,
    "cents": 3045000
  },
  {
    "id": 67674566852850,
    "cents": 3050000
  },
  {
    "id": 67674566885618,
    "cents": 3055000
  },
  {
    "id": 67674566918386,
    "cents": 3060000
  },
  {
    "id": 67674566951154,
    "cents": 3065000
  },
  {
    "id": 67674566983922,
    "cents": 3070000
  },
  {
    "id": 67674567016690,
    "cents": 3075000
  },
  {
    "id": 67674567049458,
    "cents": 3080000
  },
  {
    "id": 67674567082226,
    "cents": 3085000
  },
  {
    "id": 67674567114994,
    "cents": 3090000
  },
  {
    "id": 67674567147762,
    "cents": 3095000
  },
  {
    "id": 67674567180530,
    "cents": 3100000
  },
  {
    "id": 67674567213298,
    "cents": 3105000
  },
  {
    "id": 67674567246066,
    "cents": 3110000
  },
  {
    "id": 67674567278834,
    "cents": 3115000
  },
  {
    "id": 67674567311602,
    "cents": 3120000
  },
  {
    "id": 67674567344370,
    "cents": 3125000
  },
  {
    "id": 67674567377138,
    "cents": 3130000
  },
  {
    "id": 67674567409906,
    "cents": 3135000
  },
  {
    "id": 67674567442674,
    "cents": 3140000
  },
  {
    "id": 67674567475442,
    "cents": 3145000
  },
  {
    "id": 67674567508210,
    "cents": 3150000
  },
  {
    "id": 67674567540978,
    "cents": 3155000
  },
  {
    "id": 67674567573746,
    "cents": 3160000
  },
  {
    "id": 67674567606514,
    "cents": 3165000
  },
  {
    "id": 67674567639282,
    "cents": 3170000
  },
  {
    "id": 67674567672050,
    "cents": 3175000
  },
  {
    "id": 67674567704818,
    "cents": 3180000
  },
  {
    "id": 67674567737586,
    "cents": 3185000
  },
  {
    "id": 67674567770354,
    "cents": 3190000
  },
  {
    "id": 67674567803122,
    "cents": 3195000
  },
  {
    "id": 67674567835890,
    "cents": 3200000
  },
  {
    "id": 67674567868658,
    "cents": 3205000
  },
  {
    "id": 67674567901426,
    "cents": 3210000
  },
  {
    "id": 67674567934194,
    "cents": 3215000
  },
  {
    "id": 67674567966962,
    "cents": 3220000
  },
  {
    "id": 67674567999730,
    "cents": 3225000
  },
  {
    "id": 67674568032498,
    "cents": 3230000
  },
  {
    "id": 67674568065266,
    "cents": 3235000
  },
  {
    "id": 67674568098034,
    "cents": 3240000
  },
  {
    "id": 67674568130802,
    "cents": 3245000
  },
  {
    "id": 67674568163570,
    "cents": 3250000
  },
  {
    "id": 67674568196338,
    "cents": 3255000
  },
  {
    "id": 67674568229106,
    "cents": 3260000
  },
  {
    "id": 67674568261874,
    "cents": 3265000
  },
  {
    "id": 67674568294642,
    "cents": 3270000
  },
  {
    "id": 67674568327410,
    "cents": 3275000
  },
  {
    "id": 67674568360178,
    "cents": 3280000
  },
  {
    "id": 67674568392946,
    "cents": 3285000
  },
  {
    "id": 67674568425714,
    "cents": 3290000
  },
  {
    "id": 67674568458482,
    "cents": 3295000
  },
  {
    "id": 67674568491250,
    "cents": 3300000
  },
  {
    "id": 67674568524018,
    "cents": 3305000
  },
  {
    "id": 67674568556786,
    "cents": 3310000
  },
  {
    "id": 67674568589554,
    "cents": 3315000
  },
  {
    "id": 67674568622322,
    "cents": 3320000
  },
  {
    "id": 67674568655090,
    "cents": 3325000
  },
  {
    "id": 67674568687858,
    "cents": 3330000
  },
  {
    "id": 67674568720626,
    "cents": 3335000
  },
  {
    "id": 67674568753394,
    "cents": 3340000
  },
  {
    "id": 67674568786162,
    "cents": 3345000
  },
  {
    "id": 67674568818930,
    "cents": 3350000
  },
  {
    "id": 67674568851698,
    "cents": 3355000
  },
  {
    "id": 67674568884466,
    "cents": 3360000
  },
  {
    "id": 67674568917234,
    "cents": 3365000
  },
  {
    "id": 67674568950002,
    "cents": 3370000
  },
  {
    "id": 67674568982770,
    "cents": 3375000
  },
  {
    "id": 67674569015538,
    "cents": 3380000
  },
  {
    "id": 67674569048306,
    "cents": 3385000
  },
  {
    "id": 67674569081074,
    "cents": 3390000
  },
  {
    "id": 67674569113842,
    "cents": 3395000
  },
  {
    "id": 67674569146610,
    "cents": 3400000
  },
  {
    "id": 67674569179378,
    "cents": 3405000
  },
  {
    "id": 67674569212146,
    "cents": 3410000
  },
  {
    "id": 67674569244914,
    "cents": 3415000
  },
  {
    "id": 67674569277682,
    "cents": 3420000
  },
  {
    "id": 67674569310450,
    "cents": 3425000
  },
  {
    "id": 67674569343218,
    "cents": 3430000
  },
  {
    "id": 67674569375986,
    "cents": 3435000
  },
  {
    "id": 67674569408754,
    "cents": 3440000
  },
  {
    "id": 67674569441522,
    "cents": 3445000
  },
  {
    "id": 67674569474290,
    "cents": 3450000
  },
  {
    "id": 67674569507058,
    "cents": 3455000
  },
  {
    "id": 67674569539826,
    "cents": 3460000
  },
  {
    "id": 67674569572594,
    "cents": 3465000
  },
  {
    "id": 67674569605362,
    "cents": 3470000
  },
  {
    "id": 67674569638130,
    "cents": 3475000
  },
  {
    "id": 67674569670898,
    "cents": 3480000
  },
  {
    "id": 67674569703666,
    "cents": 3485000
  },
  {
    "id": 67674569736434,
    "cents": 3490000
  },
  {
    "id": 67674569769202,
    "cents": 3495000
  },
  {
    "id": 67674569801970,
    "cents": 3500000
  },
  {
    "id": 67674569834738,
    "cents": 3505000
  },
  {
    "id": 67674569867506,
    "cents": 3510000
  },
  {
    "id": 67674569900274,
    "cents": 3515000
  },
  {
    "id": 67674569933042,
    "cents": 3520000
  },
  {
    "id": 67674569965810,
    "cents": 3525000
  },
  {
    "id": 67674569998578,
    "cents": 3530000
  },
  {
    "id": 67674570031346,
    "cents": 3535000
  },
  {
    "id": 67674570064114,
    "cents": 3540000
  },
  {
    "id": 67674570096882,
    "cents": 3545000
  },
  {
    "id": 67674570129650,
    "cents": 3550000
  },
  {
    "id": 67674570162418,
    "cents": 3555000
  },
  {
    "id": 67674570195186,
    "cents": 3560000
  },
  {
    "id": 67674570227954,
    "cents": 3565000
  },
  {
    "id": 67674570260722,
    "cents": 3570000
  },
  {
    "id": 67674570293490,
    "cents": 3575000
  },
  {
    "id": 67674570326258,
    "cents": 3580000
  },
  {
    "id": 67674570359026,
    "cents": 3585000
  },
  {
    "id": 67674570391794,
    "cents": 3590000
  },
  {
    "id": 67674570424562,
    "cents": 3595000
  },
  {
    "id": 67674570457330,
    "cents": 3600000
  },
  {
    "id": 67674570490098,
    "cents": 3605000
  },
  {
    "id": 67674570522866,
    "cents": 3610000
  },
  {
    "id": 67674570555634,
    "cents": 3615000
  },
  {
    "id": 67674570588402,
    "cents": 3620000
  },
  {
    "id": 67674570621170,
    "cents": 3625000
  },
  {
    "id": 67674570653938,
    "cents": 3630000
  },
  {
    "id": 67674570686706,
    "cents": 3635000
  },
  {
    "id": 67674570719474,
    "cents": 3640000
  },
  {
    "id": 67674570752242,
    "cents": 3645000
  },
  {
    "id": 67674570785010,
    "cents": 3650000
  },
  {
    "id": 67674570817778,
    "cents": 3655000
  },
  {
    "id": 67674570850546,
    "cents": 3660000
  },
  {
    "id": 67674570883314,
    "cents": 3665000
  },
  {
    "id": 67674570916082,
    "cents": 3670000
  },
  {
    "id": 67674570948850,
    "cents": 3675000
  },
  {
    "id": 67674570981618,
    "cents": 3680000
  },
  {
    "id": 67674571014386,
    "cents": 3685000
  },
  {
    "id": 67674571047154,
    "cents": 3690000
  },
  {
    "id": 67674571079922,
    "cents": 3695000
  },
  {
    "id": 67674571112690,
    "cents": 3700000
  },
  {
    "id": 67674571145458,
    "cents": 3705000
  },
  {
    "id": 67674571178226,
    "cents": 3710000
  },
  {
    "id": 67674571210994,
    "cents": 3715000
  },
  {
    "id": 67674571243762,
    "cents": 3720000
  },
  {
    "id": 67674571276530,
    "cents": 3725000
  },
  {
    "id": 67674571309298,
    "cents": 3730000
  },
  {
    "id": 67674571342066,
    "cents": 3735000
  },
  {
    "id": 67674571374834,
    "cents": 3740000
  },
  {
    "id": 67674571407602,
    "cents": 3745000
  },
  {
    "id": 67674571440370,
    "cents": 3750000
  },
  {
    "id": 67674571473138,
    "cents": 3755000
  },
  {
    "id": 67674571505906,
    "cents": 3760000
  },
  {
    "id": 67674571538674,
    "cents": 3765000
  },
  {
    "id": 67674571571442,
    "cents": 3770000
  },
  {
    "id": 67674571604210,
    "cents": 3775000
  },
  {
    "id": 67674571636978,
    "cents": 3780000
  },
  {
    "id": 67674571669746,
    "cents": 3785000
  },
  {
    "id": 67674571702514,
    "cents": 3790000
  },
  {
    "id": 67674571735282,
    "cents": 3795000
  },
  {
    "id": 67674571768050,
    "cents": 3800000
  },
  {
    "id": 67674571800818,
    "cents": 3805000
  },
  {
    "id": 67674571833586,
    "cents": 3810000
  },
  {
    "id": 67674571866354,
    "cents": 3815000
  },
  {
    "id": 67674571899122,
    "cents": 3820000
  },
  {
    "id": 67674571931890,
    "cents": 3825000
  },
  {
    "id": 67674571964658,
    "cents": 3830000
  },
  {
    "id": 67674571997426,
    "cents": 3835000
  },
  {
    "id": 67674572030194,
    "cents": 3840000
  },
  {
    "id": 67674572062962,
    "cents": 3845000
  },
  {
    "id": 67674572095730,
    "cents": 3850000
  },
  {
    "id": 67674572128498,
    "cents": 3855000
  },
  {
    "id": 67674572161266,
    "cents": 3860000
  },
  {
    "id": 67674572194034,
    "cents": 3865000
  },
  {
    "id": 67674572226802,
    "cents": 3870000
  },
  {
    "id": 67674572259570,
    "cents": 3875000
  },
  {
    "id": 67674572292338,
    "cents": 3880000
  },
  {
    "id": 67674572325106,
    "cents": 3885000
  },
  {
    "id": 67674572357874,
    "cents": 3890000
  },
  {
    "id": 67674572390642,
    "cents": 3895000
  },
  {
    "id": 67674572423410,
    "cents": 3900000
  },
  {
    "id": 67674572456178,
    "cents": 3905000
  },
  {
    "id": 67674572488946,
    "cents": 3910000
  },
  {
    "id": 67674572521714,
    "cents": 3915000
  },
  {
    "id": 67674572554482,
    "cents": 3920000
  },
  {
    "id": 67674572587250,
    "cents": 3925000
  },
  {
    "id": 67674572620018,
    "cents": 3930000
  },
  {
    "id": 67674572652786,
    "cents": 3935000
  },
  {
    "id": 67674572685554,
    "cents": 3940000
  },
  {
    "id": 67674572718322,
    "cents": 3945000
  },
  {
    "id": 67674572751090,
    "cents": 3950000
  },
  {
    "id": 67674572783858,
    "cents": 3955000
  },
  {
    "id": 67674572816626,
    "cents": 3960000
  },
  {
    "id": 67674572849394,
    "cents": 3965000
  },
  {
    "id": 67674572882162,
    "cents": 3970000
  },
  {
    "id": 67674572914930,
    "cents": 3975000
  },
  {
    "id": 67674572947698,
    "cents": 3980000
  },
  {
    "id": 67674572980466,
    "cents": 3985000
  },
  {
    "id": 67674573013234,
    "cents": 3990000
  },
  {
    "id": 67674573046002,
    "cents": 3995000
  },
  {
    "id": 67674573078770,
    "cents": 4000000
  },
  {
    "id": 67674573111538,
    "cents": 4005000
  },
  {
    "id": 67674573144306,
    "cents": 4010000
  },
  {
    "id": 67674573177074,
    "cents": 4015000
  },
  {
    "id": 67674573570290,
    "cents": 4020000
  },
  {
    "id": 67674573603058,
    "cents": 4025000
  },
  {
    "id": 67674573635826,
    "cents": 4030000
  },
  {
    "id": 67674573668594,
    "cents": 4035000
  },
  {
    "id": 67674573701362,
    "cents": 4040000
  },
  {
    "id": 67674573734130,
    "cents": 4045000
  },
  {
    "id": 67674573766898,
    "cents": 4050000
  },
  {
    "id": 67674573799666,
    "cents": 4055000
  },
  {
    "id": 67674573832434,
    "cents": 4060000
  },
  {
    "id": 67674573865202,
    "cents": 4065000
  },
  {
    "id": 67674573897970,
    "cents": 4070000
  },
  {
    "id": 67674573930738,
    "cents": 4075000
  },
  {
    "id": 67674573963506,
    "cents": 4080000
  },
  {
    "id": 67674573996274,
    "cents": 4085000
  },
  {
    "id": 67674574029042,
    "cents": 4090000
  },
  {
    "id": 67674574061810,
    "cents": 4095000
  },
  {
    "id": 67674574094578,
    "cents": 4100000
  },
  {
    "id": 67674574127346,
    "cents": 4105000
  },
  {
    "id": 67674574160114,
    "cents": 4110000
  },
  {
    "id": 67674574192882,
    "cents": 4115000
  },
  {
    "id": 67674574225650,
    "cents": 4120000
  },
  {
    "id": 67674574258418,
    "cents": 4125000
  },
  {
    "id": 67674574291186,
    "cents": 4130000
  },
  {
    "id": 67674574323954,
    "cents": 4135000
  },
  {
    "id": 67674574356722,
    "cents": 4140000
  },
  {
    "id": 67674574389490,
    "cents": 4145000
  },
  {
    "id": 67674574422258,
    "cents": 4150000
  },
  {
    "id": 67674574455026,
    "cents": 4155000
  },
  {
    "id": 67674574487794,
    "cents": 4160000
  },
  {
    "id": 67674574520562,
    "cents": 4165000
  },
  {
    "id": 67674574553330,
    "cents": 4170000
  },
  {
    "id": 67674574586098,
    "cents": 4175000
  },
  {
    "id": 67674574618866,
    "cents": 4180000
  },
  {
    "id": 67674574651634,
    "cents": 4185000
  },
  {
    "id": 67674574684402,
    "cents": 4190000
  },
  {
    "id": 67674574717170,
    "cents": 4195000
  },
  {
    "id": 67674574749938,
    "cents": 4200000
  },
  {
    "id": 67674574782706,
    "cents": 4205000
  },
  {
    "id": 67674574815474,
    "cents": 4210000
  },
  {
    "id": 67674574848242,
    "cents": 4215000
  },
  {
    "id": 67674574881010,
    "cents": 4220000
  },
  {
    "id": 67674574913778,
    "cents": 4225000
  },
  {
    "id": 67674574946546,
    "cents": 4230000
  },
  {
    "id": 67674574979314,
    "cents": 4235000
  },
  {
    "id": 67674575012082,
    "cents": 4240000
  },
  {
    "id": 67674575044850,
    "cents": 4245000
  },
  {
    "id": 67674575077618,
    "cents": 4250000
  },
  {
    "id": 67674575110386,
    "cents": 4255000
  },
  {
    "id": 67674575143154,
    "cents": 4260000
  },
  {
    "id": 67674575175922,
    "cents": 4265000
  },
  {
    "id": 67674575208690,
    "cents": 4270000
  },
  {
    "id": 67674575241458,
    "cents": 4275000
  },
  {
    "id": 67674575274226,
    "cents": 4280000
  },
  {
    "id": 67674575306994,
    "cents": 4285000
  },
  {
    "id": 67674575339762,
    "cents": 4290000
  },
  {
    "id": 67674575372530,
    "cents": 4295000
  },
  {
    "id": 67674575405298,
    "cents": 4300000
  },
  {
    "id": 67674575438066,
    "cents": 4305000
  },
  {
    "id": 67674575470834,
    "cents": 4310000
  },
  {
    "id": 67674575503602,
    "cents": 4315000
  },
  {
    "id": 67674575536370,
    "cents": 4320000
  },
  {
    "id": 67674575569138,
    "cents": 4325000
  },
  {
    "id": 67674575601906,
    "cents": 4330000
  },
  {
    "id": 67674575634674,
    "cents": 4335000
  },
  {
    "id": 67674575667442,
    "cents": 4340000
  },
  {
    "id": 67674575700210,
    "cents": 4345000
  },
  {
    "id": 67674575732978,
    "cents": 4350000
  },
  {
    "id": 67674575765746,
    "cents": 4355000
  },
  {
    "id": 67674575798514,
    "cents": 4360000
  },
  {
    "id": 67674575831282,
    "cents": 4365000
  },
  {
    "id": 67674575864050,
    "cents": 4370000
  },
  {
    "id": 67674575896818,
    "cents": 4375000
  },
  {
    "id": 67674575929586,
    "cents": 4380000
  },
  {
    "id": 67674575962354,
    "cents": 4385000
  },
  {
    "id": 67674575995122,
    "cents": 4390000
  },
  {
    "id": 67674576027890,
    "cents": 4395000
  },
  {
    "id": 67674576060658,
    "cents": 4400000
  },
  {
    "id": 67674576093426,
    "cents": 4405000
  },
  {
    "id": 67674576126194,
    "cents": 4410000
  },
  {
    "id": 67674576158962,
    "cents": 4415000
  },
  {
    "id": 67674576191730,
    "cents": 4420000
  },
  {
    "id": 67674576224498,
    "cents": 4425000
  },
  {
    "id": 67674576257266,
    "cents": 4430000
  },
  {
    "id": 67674576290034,
    "cents": 4435000
  },
  {
    "id": 67674576322802,
    "cents": 4440000
  },
  {
    "id": 67674576355570,
    "cents": 4445000
  },
  {
    "id": 67674576388338,
    "cents": 4450000
  },
  {
    "id": 67674576421106,
    "cents": 4455000
  },
  {
    "id": 67674576453874,
    "cents": 4460000
  },
  {
    "id": 67674576486642,
    "cents": 4465000
  },
  {
    "id": 67674576519410,
    "cents": 4470000
  },
  {
    "id": 67674576552178,
    "cents": 4475000
  },
  {
    "id": 67674576584946,
    "cents": 4480000
  },
  {
    "id": 67674576617714,
    "cents": 4485000
  },
  {
    "id": 67674576650482,
    "cents": 4490000
  },
  {
    "id": 67674576683250,
    "cents": 4495000
  },
  {
    "id": 67674576716018,
    "cents": 4500000
  },
  {
    "id": 67674576748786,
    "cents": 4505000
  },
  {
    "id": 67674576781554,
    "cents": 4510000
  },
  {
    "id": 67674576814322,
    "cents": 4515000
  },
  {
    "id": 67674576847090,
    "cents": 4520000
  },
  {
    "id": 67674576879858,
    "cents": 4525000
  },
  {
    "id": 67674576912626,
    "cents": 4530000
  },
  {
    "id": 67674576945394,
    "cents": 4535000
  },
  {
    "id": 67674576978162,
    "cents": 4540000
  },
  {
    "id": 67674577010930,
    "cents": 4545000
  },
  {
    "id": 67674577043698,
    "cents": 4550000
  },
  {
    "id": 67674577076466,
    "cents": 4555000
  },
  {
    "id": 67674577109234,
    "cents": 4560000
  },
  {
    "id": 67674577142002,
    "cents": 4565000
  },
  {
    "id": 67674577174770,
    "cents": 4570000
  },
  {
    "id": 67674577207538,
    "cents": 4575000
  },
  {
    "id": 67674577240306,
    "cents": 4580000
  },
  {
    "id": 67674577273074,
    "cents": 4585000
  },
  {
    "id": 67674577305842,
    "cents": 4590000
  },
  {
    "id": 67674577338610,
    "cents": 4595000
  },
  {
    "id": 67674577371378,
    "cents": 4600000
  },
  {
    "id": 67674577404146,
    "cents": 4605000
  },
  {
    "id": 67674577436914,
    "cents": 4610000
  },
  {
    "id": 67674577469682,
    "cents": 4615000
  },
  {
    "id": 67674577502450,
    "cents": 4620000
  },
  {
    "id": 67674577535218,
    "cents": 4625000
  },
  {
    "id": 67674577567986,
    "cents": 4630000
  },
  {
    "id": 67674577600754,
    "cents": 4635000
  },
  {
    "id": 67674577633522,
    "cents": 4640000
  },
  {
    "id": 67674577666290,
    "cents": 4645000
  },
  {
    "id": 67674577699058,
    "cents": 4650000
  },
  {
    "id": 67674577731826,
    "cents": 4655000
  },
  {
    "id": 67674577764594,
    "cents": 4660000
  },
  {
    "id": 67674577797362,
    "cents": 4665000
  },
  {
    "id": 67674577830130,
    "cents": 4670000
  },
  {
    "id": 67674577862898,
    "cents": 4675000
  },
  {
    "id": 67674577895666,
    "cents": 4680000
  },
  {
    "id": 67674577928434,
    "cents": 4685000
  },
  {
    "id": 67674577961202,
    "cents": 4690000
  },
  {
    "id": 67674577993970,
    "cents": 4695000
  },
  {
    "id": 67674578026738,
    "cents": 4700000
  },
  {
    "id": 67674578059506,
    "cents": 4705000
  },
  {
    "id": 67674578092274,
    "cents": 4710000
  },
  {
    "id": 67674578125042,
    "cents": 4715000
  },
  {
    "id": 67674578157810,
    "cents": 4720000
  },
  {
    "id": 67674578190578,
    "cents": 4725000
  },
  {
    "id": 67674578223346,
    "cents": 4730000
  },
  {
    "id": 67674578256114,
    "cents": 4735000
  },
  {
    "id": 67674578288882,
    "cents": 4740000
  },
  {
    "id": 67674578321650,
    "cents": 4745000
  },
  {
    "id": 67674578354418,
    "cents": 4750000
  },
  {
    "id": 67674578387186,
    "cents": 4755000
  },
  {
    "id": 67674578419954,
    "cents": 4760000
  },
  {
    "id": 67674578452722,
    "cents": 4765000
  },
  {
    "id": 67674578485490,
    "cents": 4770000
  },
  {
    "id": 67674578518258,
    "cents": 4775000
  },
  {
    "id": 67674578551026,
    "cents": 4780000
  },
  {
    "id": 67674578583794,
    "cents": 4785000
  },
  {
    "id": 67674578616562,
    "cents": 4790000
  },
  {
    "id": 67674578649330,
    "cents": 4795000
  },
  {
    "id": 67674578682098,
    "cents": 4800000
  },
  {
    "id": 67674578714866,
    "cents": 4805000
  },
  {
    "id": 67674578747634,
    "cents": 4810000
  },
  {
    "id": 67674578780402,
    "cents": 4815000
  },
  {
    "id": 67674578813170,
    "cents": 4820000
  },
  {
    "id": 67674578845938,
    "cents": 4825000
  },
  {
    "id": 67674578878706,
    "cents": 4830000
  },
  {
    "id": 67674578911474,
    "cents": 4835000
  },
  {
    "id": 67674578944242,
    "cents": 4840000
  },
  {
    "id": 67674578977010,
    "cents": 4845000
  },
  {
    "id": 67674579009778,
    "cents": 4850000
  },
  {
    "id": 67674579042546,
    "cents": 4855000
  },
  {
    "id": 67674579075314,
    "cents": 4860000
  },
  {
    "id": 67674579108082,
    "cents": 4865000
  },
  {
    "id": 67674579140850,
    "cents": 4870000
  },
  {
    "id": 67674579173618,
    "cents": 4875000
  },
  {
    "id": 67674579206386,
    "cents": 4880000
  },
  {
    "id": 67674579239154,
    "cents": 4885000
  },
  {
    "id": 67674579271922,
    "cents": 4890000
  },
  {
    "id": 67674579304690,
    "cents": 4895000
  },
  {
    "id": 67674579337458,
    "cents": 4900000
  },
  {
    "id": 67674579370226,
    "cents": 4905000
  },
  {
    "id": 67674579402994,
    "cents": 4910000
  },
  {
    "id": 67674579435762,
    "cents": 4915000
  },
  {
    "id": 67674579468530,
    "cents": 4920000
  },
  {
    "id": 67674579501298,
    "cents": 4925000
  },
  {
    "id": 67674579534066,
    "cents": 4930000
  },
  {
    "id": 67674579566834,
    "cents": 4935000
  },
  {
    "id": 67674579599602,
    "cents": 4940000
  },
  {
    "id": 67674579632370,
    "cents": 4945000
  },
  {
    "id": 67674579665138,
    "cents": 4950000
  },
  {
    "id": 67674579697906,
    "cents": 4955000
  },
  {
    "id": 67674579730674,
    "cents": 4960000
  },
  {
    "id": 67674579763442,
    "cents": 4965000
  },
  {
    "id": 67674579796210,
    "cents": 4970000
  },
  {
    "id": 67674579828978,
    "cents": 4975000
  },
  {
    "id": 67674579861746,
    "cents": 4980000
  },
  {
    "id": 67674579894514,
    "cents": 4985000
  },
  {
    "id": 67674579927282,
    "cents": 4990000
  },
  {
    "id": 67674579960050,
    "cents": 4995000
  },
  {
    "id": 67674579992818,
    "cents": 5000000
  },
  {
    "id": 67674580025586,
    "cents": 5005000
  },
  {
    "id": 67674580058354,
    "cents": 5010000
  },
  {
    "id": 67674580091122,
    "cents": 5015000
  },
  {
    "id": 67674580287730,
    "cents": 5020000
  },
  {
    "id": 67674580320498,
    "cents": 5025000
  },
  {
    "id": 67674580353266,
    "cents": 5030000
  },
  {
    "id": 67674580386034,
    "cents": 5035000
  },
  {
    "id": 67674580418802,
    "cents": 5040000
  },
  {
    "id": 67674580451570,
    "cents": 5045000
  },
  {
    "id": 67674580484338,
    "cents": 5050000
  },
  {
    "id": 67674580517106,
    "cents": 5055000
  },
  {
    "id": 67674580549874,
    "cents": 5060000
  },
  {
    "id": 67674580582642,
    "cents": 5065000
  },
  {
    "id": 67674580615410,
    "cents": 5070000
  },
  {
    "id": 67674580648178,
    "cents": 5075000
  },
  {
    "id": 67674580680946,
    "cents": 5080000
  },
  {
    "id": 67674580713714,
    "cents": 5085000
  },
  {
    "id": 67674580746482,
    "cents": 5090000
  },
  {
    "id": 67674580779250,
    "cents": 5095000
  },
  {
    "id": 67674580812018,
    "cents": 5100000
  },
  {
    "id": 67674580844786,
    "cents": 5105000
  },
  {
    "id": 67674580877554,
    "cents": 5110000
  },
  {
    "id": 67674580910322,
    "cents": 5115000
  },
  {
    "id": 67674580943090,
    "cents": 5120000
  },
  {
    "id": 67674580975858,
    "cents": 5125000
  },
  {
    "id": 67674581008626,
    "cents": 5130000
  },
  {
    "id": 67674581041394,
    "cents": 5135000
  },
  {
    "id": 67674581074162,
    "cents": 5140000
  },
  {
    "id": 67674581106930,
    "cents": 5145000
  },
  {
    "id": 67674581139698,
    "cents": 5150000
  },
  {
    "id": 67674581172466,
    "cents": 5155000
  },
  {
    "id": 67674581205234,
    "cents": 5160000
  },
  {
    "id": 67674581238002,
    "cents": 5165000
  },
  {
    "id": 67674581270770,
    "cents": 5170000
  },
  {
    "id": 67674581303538,
    "cents": 5175000
  },
  {
    "id": 67674581336306,
    "cents": 5180000
  },
  {
    "id": 67674581369074,
    "cents": 5185000
  },
  {
    "id": 67674581401842,
    "cents": 5190000
  },
  {
    "id": 67674581434610,
    "cents": 5195000
  },
  {
    "id": 67674581467378,
    "cents": 5200000
  },
  {
    "id": 67674581500146,
    "cents": 5205000
  },
  {
    "id": 67674581532914,
    "cents": 5210000
  },
  {
    "id": 67674581565682,
    "cents": 5215000
  },
  {
    "id": 67674581598450,
    "cents": 5220000
  },
  {
    "id": 67674581631218,
    "cents": 5225000
  },
  {
    "id": 67674581663986,
    "cents": 5230000
  },
  {
    "id": 67674581696754,
    "cents": 5235000
  },
  {
    "id": 67674581729522,
    "cents": 5240000
  },
  {
    "id": 67674581762290,
    "cents": 5245000
  },
  {
    "id": 67674581795058,
    "cents": 5250000
  },
  {
    "id": 67674581827826,
    "cents": 5255000
  },
  {
    "id": 67674581860594,
    "cents": 5260000
  },
  {
    "id": 67674581893362,
    "cents": 5265000
  },
  {
    "id": 67674581926130,
    "cents": 5270000
  },
  {
    "id": 67674581958898,
    "cents": 5275000
  },
  {
    "id": 67674581991666,
    "cents": 5280000
  },
  {
    "id": 67674582024434,
    "cents": 5285000
  },
  {
    "id": 67674582057202,
    "cents": 5290000
  },
  {
    "id": 67674582089970,
    "cents": 5295000
  },
  {
    "id": 67674582122738,
    "cents": 5300000
  },
  {
    "id": 67674582155506,
    "cents": 5305000
  },
  {
    "id": 67674582188274,
    "cents": 5310000
  },
  {
    "id": 67674582221042,
    "cents": 5315000
  },
  {
    "id": 67674582253810,
    "cents": 5320000
  },
  {
    "id": 67674582286578,
    "cents": 5325000
  },
  {
    "id": 67674582319346,
    "cents": 5330000
  },
  {
    "id": 67674582352114,
    "cents": 5335000
  },
  {
    "id": 67674582384882,
    "cents": 5340000
  },
  {
    "id": 67674582417650,
    "cents": 5345000
  },
  {
    "id": 67674582450418,
    "cents": 5350000
  },
  {
    "id": 67674582483186,
    "cents": 5355000
  },
  {
    "id": 67674582515954,
    "cents": 5360000
  },
  {
    "id": 67674582548722,
    "cents": 5365000
  },
  {
    "id": 67674582581490,
    "cents": 5370000
  },
  {
    "id": 67674582614258,
    "cents": 5375000
  },
  {
    "id": 67674582647026,
    "cents": 5380000
  },
  {
    "id": 67674582679794,
    "cents": 5385000
  },
  {
    "id": 67674582712562,
    "cents": 5390000
  },
  {
    "id": 67674582745330,
    "cents": 5395000
  },
  {
    "id": 67674582778098,
    "cents": 5400000
  },
  {
    "id": 67674582810866,
    "cents": 5405000
  },
  {
    "id": 67674582843634,
    "cents": 5410000
  },
  {
    "id": 67674582876402,
    "cents": 5415000
  },
  {
    "id": 67674582909170,
    "cents": 5420000
  },
  {
    "id": 67674582941938,
    "cents": 5425000
  },
  {
    "id": 67674582974706,
    "cents": 5430000
  },
  {
    "id": 67674583007474,
    "cents": 5435000
  },
  {
    "id": 67674583040242,
    "cents": 5440000
  },
  {
    "id": 67674583073010,
    "cents": 5445000
  },
  {
    "id": 67674583105778,
    "cents": 5450000
  },
  {
    "id": 67674583138546,
    "cents": 5455000
  },
  {
    "id": 67674583171314,
    "cents": 5460000
  },
  {
    "id": 67674583204082,
    "cents": 5465000
  },
  {
    "id": 67674583236850,
    "cents": 5470000
  },
  {
    "id": 67674583269618,
    "cents": 5475000
  },
  {
    "id": 67674583302386,
    "cents": 5480000
  },
  {
    "id": 67674583335154,
    "cents": 5485000
  },
  {
    "id": 67674583367922,
    "cents": 5490000
  },
  {
    "id": 67674583400690,
    "cents": 5495000
  },
  {
    "id": 67674583433458,
    "cents": 5500000
  },
  {
    "id": 67674583466226,
    "cents": 5505000
  },
  {
    "id": 67674583498994,
    "cents": 5510000
  },
  {
    "id": 67674583531762,
    "cents": 5515000
  },
  {
    "id": 67674583564530,
    "cents": 5520000
  },
  {
    "id": 67674583597298,
    "cents": 5525000
  },
  {
    "id": 67674583630066,
    "cents": 5530000
  },
  {
    "id": 67674583662834,
    "cents": 5535000
  },
  {
    "id": 67674583695602,
    "cents": 5540000
  },
  {
    "id": 67674583728370,
    "cents": 5545000
  },
  {
    "id": 67674583761138,
    "cents": 5550000
  },
  {
    "id": 67674583793906,
    "cents": 5555000
  },
  {
    "id": 67674583826674,
    "cents": 5560000
  },
  {
    "id": 67674583859442,
    "cents": 5565000
  },
  {
    "id": 67674583892210,
    "cents": 5570000
  },
  {
    "id": 67674583924978,
    "cents": 5575000
  },
  {
    "id": 67674583957746,
    "cents": 5580000
  },
  {
    "id": 67674583990514,
    "cents": 5585000
  },
  {
    "id": 67674584023282,
    "cents": 5590000
  },
  {
    "id": 67674584056050,
    "cents": 5595000
  },
  {
    "id": 67674584088818,
    "cents": 5600000
  },
  {
    "id": 67674584121586,
    "cents": 5605000
  },
  {
    "id": 67674584154354,
    "cents": 5610000
  },
  {
    "id": 67674584187122,
    "cents": 5615000
  },
  {
    "id": 67674584219890,
    "cents": 5620000
  },
  {
    "id": 67674584252658,
    "cents": 5625000
  },
  {
    "id": 67674584285426,
    "cents": 5630000
  },
  {
    "id": 67674584318194,
    "cents": 5635000
  },
  {
    "id": 67674584350962,
    "cents": 5640000
  },
  {
    "id": 67674584383730,
    "cents": 5645000
  },
  {
    "id": 67674584416498,
    "cents": 5650000
  },
  {
    "id": 67674584449266,
    "cents": 5655000
  },
  {
    "id": 67674584482034,
    "cents": 5660000
  },
  {
    "id": 67674584514802,
    "cents": 5665000
  },
  {
    "id": 67674584547570,
    "cents": 5670000
  },
  {
    "id": 67674584580338,
    "cents": 5675000
  },
  {
    "id": 67674584613106,
    "cents": 5680000
  },
  {
    "id": 67674584645874,
    "cents": 5685000
  },
  {
    "id": 67674584678642,
    "cents": 5690000
  },
  {
    "id": 67674584711410,
    "cents": 5695000
  },
  {
    "id": 67674584744178,
    "cents": 5700000
  },
  {
    "id": 67674584776946,
    "cents": 5705000
  },
  {
    "id": 67674584809714,
    "cents": 5710000
  },
  {
    "id": 67674584842482,
    "cents": 5715000
  },
  {
    "id": 67674584875250,
    "cents": 5720000
  },
  {
    "id": 67674584908018,
    "cents": 5725000
  },
  {
    "id": 67674584940786,
    "cents": 5730000
  },
  {
    "id": 67674584973554,
    "cents": 5735000
  },
  {
    "id": 67674585006322,
    "cents": 5740000
  },
  {
    "id": 67674585039090,
    "cents": 5745000
  },
  {
    "id": 67674585071858,
    "cents": 5750000
  },
  {
    "id": 67674585104626,
    "cents": 5755000
  },
  {
    "id": 67674585137394,
    "cents": 5760000
  },
  {
    "id": 67674585170162,
    "cents": 5765000
  },
  {
    "id": 67674585202930,
    "cents": 5770000
  },
  {
    "id": 67674585235698,
    "cents": 5775000
  },
  {
    "id": 67674585268466,
    "cents": 5780000
  },
  {
    "id": 67674585301234,
    "cents": 5785000
  },
  {
    "id": 67674585334002,
    "cents": 5790000
  },
  {
    "id": 67674585366770,
    "cents": 5795000
  },
  {
    "id": 67674585399538,
    "cents": 5800000
  },
  {
    "id": 67674585432306,
    "cents": 5805000
  },
  {
    "id": 67674585465074,
    "cents": 5810000
  },
  {
    "id": 67674585497842,
    "cents": 5815000
  },
  {
    "id": 67674585530610,
    "cents": 5820000
  },
  {
    "id": 67674585563378,
    "cents": 5825000
  },
  {
    "id": 67674585596146,
    "cents": 5830000
  },
  {
    "id": 67674585628914,
    "cents": 5835000
  },
  {
    "id": 67674585661682,
    "cents": 5840000
  },
  {
    "id": 67674585694450,
    "cents": 5845000
  },
  {
    "id": 67674585727218,
    "cents": 5850000
  },
  {
    "id": 67674585759986,
    "cents": 5855000
  },
  {
    "id": 67674585792754,
    "cents": 5860000
  },
  {
    "id": 67674585825522,
    "cents": 5865000
  },
  {
    "id": 67674585858290,
    "cents": 5870000
  },
  {
    "id": 67674585891058,
    "cents": 5875000
  },
  {
    "id": 67674585923826,
    "cents": 5880000
  },
  {
    "id": 67674585956594,
    "cents": 5885000
  },
  {
    "id": 67674585989362,
    "cents": 5890000
  },
  {
    "id": 67674586022130,
    "cents": 5895000
  },
  {
    "id": 67674586054898,
    "cents": 5900000
  },
  {
    "id": 67674586087666,
    "cents": 5905000
  },
  {
    "id": 67674586120434,
    "cents": 5910000
  },
  {
    "id": 67674586153202,
    "cents": 5915000
  },
  {
    "id": 67674586185970,
    "cents": 5920000
  },
  {
    "id": 67674586218738,
    "cents": 5925000
  },
  {
    "id": 67674586251506,
    "cents": 5930000
  },
  {
    "id": 67674586284274,
    "cents": 5935000
  },
  {
    "id": 67674586317042,
    "cents": 5940000
  },
  {
    "id": 67674586349810,
    "cents": 5945000
  },
  {
    "id": 67674586382578,
    "cents": 5950000
  },
  {
    "id": 67674586415346,
    "cents": 5955000
  },
  {
    "id": 67674586448114,
    "cents": 5960000
  },
  {
    "id": 67674586480882,
    "cents": 5965000
  },
  {
    "id": 67674586513650,
    "cents": 5970000
  },
  {
    "id": 67674586546418,
    "cents": 5975000
  },
  {
    "id": 67674586579186,
    "cents": 5980000
  },
  {
    "id": 67674586611954,
    "cents": 5985000
  },
  {
    "id": 67674586644722,
    "cents": 5990000
  },
  {
    "id": 67674586677490,
    "cents": 5995000
  },
  {
    "id": 67674586710258,
    "cents": 6000000
  },
  {
    "id": 67674586743026,
    "cents": 6005000
  },
  {
    "id": 67674586775794,
    "cents": 6010000
  },
  {
    "id": 67674586808562,
    "cents": 6015000
  },
  {
    "id": 67674587201778,
    "cents": 6020000
  },
  {
    "id": 67674587234546,
    "cents": 6025000
  },
  {
    "id": 67674587267314,
    "cents": 6030000
  },
  {
    "id": 67674587300082,
    "cents": 6035000
  },
  {
    "id": 67674587332850,
    "cents": 6040000
  },
  {
    "id": 67674587365618,
    "cents": 6045000
  },
  {
    "id": 67674587398386,
    "cents": 6050000
  },
  {
    "id": 67674587431154,
    "cents": 6055000
  },
  {
    "id": 67674587463922,
    "cents": 6060000
  },
  {
    "id": 67674587496690,
    "cents": 6065000
  },
  {
    "id": 67674587529458,
    "cents": 6070000
  },
  {
    "id": 67674587562226,
    "cents": 6075000
  },
  {
    "id": 67674587594994,
    "cents": 6080000
  },
  {
    "id": 67674587627762,
    "cents": 6085000
  },
  {
    "id": 67674587660530,
    "cents": 6090000
  },
  {
    "id": 67674587693298,
    "cents": 6095000
  },
  {
    "id": 67674587726066,
    "cents": 6100000
  },
  {
    "id": 67674587758834,
    "cents": 6105000
  },
  {
    "id": 67674587791602,
    "cents": 6110000
  },
  {
    "id": 67674587824370,
    "cents": 6115000
  },
  {
    "id": 67674587857138,
    "cents": 6120000
  },
  {
    "id": 67674587889906,
    "cents": 6125000
  },
  {
    "id": 67674587922674,
    "cents": 6130000
  },
  {
    "id": 67674587955442,
    "cents": 6135000
  },
  {
    "id": 67674587988210,
    "cents": 6140000
  },
  {
    "id": 67674588020978,
    "cents": 6145000
  },
  {
    "id": 67674588053746,
    "cents": 6150000
  },
  {
    "id": 67674588086514,
    "cents": 6155000
  },
  {
    "id": 67674588119282,
    "cents": 6160000
  },
  {
    "id": 67674588152050,
    "cents": 6165000
  },
  {
    "id": 67674588184818,
    "cents": 6170000
  },
  {
    "id": 67674588217586,
    "cents": 6175000
  },
  {
    "id": 67674588250354,
    "cents": 6180000
  },
  {
    "id": 67674588283122,
    "cents": 6185000
  },
  {
    "id": 67674588315890,
    "cents": 6190000
  },
  {
    "id": 67674588348658,
    "cents": 6195000
  },
  {
    "id": 67674588381426,
    "cents": 6200000
  },
  {
    "id": 67674588414194,
    "cents": 6205000
  },
  {
    "id": 67674588446962,
    "cents": 6210000
  },
  {
    "id": 67674588479730,
    "cents": 6215000
  },
  {
    "id": 67674588512498,
    "cents": 6220000
  },
  {
    "id": 67674588545266,
    "cents": 6225000
  },
  {
    "id": 67674588578034,
    "cents": 6230000
  },
  {
    "id": 67674588610802,
    "cents": 6235000
  },
  {
    "id": 67674588643570,
    "cents": 6240000
  },
  {
    "id": 67674588676338,
    "cents": 6245000
  },
  {
    "id": 67674588709106,
    "cents": 6250000
  },
  {
    "id": 67674588741874,
    "cents": 6255000
  },
  {
    "id": 67674588774642,
    "cents": 6260000
  },
  {
    "id": 67674588807410,
    "cents": 6265000
  },
  {
    "id": 67674588840178,
    "cents": 6270000
  },
  {
    "id": 67674588872946,
    "cents": 6275000
  },
  {
    "id": 67674588905714,
    "cents": 6280000
  },
  {
    "id": 67674588938482,
    "cents": 6285000
  },
  {
    "id": 67674588971250,
    "cents": 6290000
  },
  {
    "id": 67674589004018,
    "cents": 6295000
  },
  {
    "id": 67674589036786,
    "cents": 6300000
  },
  {
    "id": 67674589069554,
    "cents": 6305000
  },
  {
    "id": 67674589102322,
    "cents": 6310000
  },
  {
    "id": 67674589135090,
    "cents": 6315000
  },
  {
    "id": 67674589167858,
    "cents": 6320000
  },
  {
    "id": 67674589200626,
    "cents": 6325000
  },
  {
    "id": 67674589233394,
    "cents": 6330000
  },
  {
    "id": 67674589266162,
    "cents": 6335000
  },
  {
    "id": 67674589298930,
    "cents": 6340000
  },
  {
    "id": 67674589331698,
    "cents": 6345000
  },
  {
    "id": 67674589364466,
    "cents": 6350000
  },
  {
    "id": 67674589397234,
    "cents": 6355000
  },
  {
    "id": 67674589430002,
    "cents": 6360000
  },
  {
    "id": 67674589462770,
    "cents": 6365000
  },
  {
    "id": 67674589495538,
    "cents": 6370000
  },
  {
    "id": 67674589528306,
    "cents": 6375000
  },
  {
    "id": 67674589561074,
    "cents": 6380000
  },
  {
    "id": 67674589593842,
    "cents": 6385000
  },
  {
    "id": 67674589626610,
    "cents": 6390000
  },
  {
    "id": 67674589659378,
    "cents": 6395000
  },
  {
    "id": 67674589692146,
    "cents": 6400000
  },
  {
    "id": 67674589724914,
    "cents": 6405000
  },
  {
    "id": 67674589757682,
    "cents": 6410000
  },
  {
    "id": 67674589790450,
    "cents": 6415000
  },
  {
    "id": 67674589823218,
    "cents": 6420000
  },
  {
    "id": 67674589855986,
    "cents": 6425000
  },
  {
    "id": 67674589888754,
    "cents": 6430000
  },
  {
    "id": 67674589921522,
    "cents": 6435000
  },
  {
    "id": 67674589954290,
    "cents": 6440000
  },
  {
    "id": 67674589987058,
    "cents": 6445000
  },
  {
    "id": 67674590019826,
    "cents": 6450000
  },
  {
    "id": 67674590052594,
    "cents": 6455000
  },
  {
    "id": 67674590085362,
    "cents": 6460000
  },
  {
    "id": 67674590118130,
    "cents": 6465000
  },
  {
    "id": 67674590150898,
    "cents": 6470000
  },
  {
    "id": 67674590183666,
    "cents": 6475000
  },
  {
    "id": 67674590216434,
    "cents": 6480000
  },
  {
    "id": 67674590249202,
    "cents": 6485000
  },
  {
    "id": 67674590281970,
    "cents": 6490000
  },
  {
    "id": 67674590314738,
    "cents": 6495000
  },
  {
    "id": 67674590347506,
    "cents": 6500000
  },
  {
    "id": 67674590380274,
    "cents": 6505000
  },
  {
    "id": 67674590413042,
    "cents": 6510000
  },
  {
    "id": 67674590445810,
    "cents": 6515000
  },
  {
    "id": 67674590478578,
    "cents": 6520000
  },
  {
    "id": 67674590511346,
    "cents": 6525000
  },
  {
    "id": 67674590544114,
    "cents": 6530000
  },
  {
    "id": 67674590576882,
    "cents": 6535000
  },
  {
    "id": 67674590609650,
    "cents": 6540000
  },
  {
    "id": 67674590642418,
    "cents": 6545000
  },
  {
    "id": 67674590675186,
    "cents": 6550000
  },
  {
    "id": 67674590707954,
    "cents": 6555000
  },
  {
    "id": 67674590740722,
    "cents": 6560000
  },
  {
    "id": 67674590773490,
    "cents": 6565000
  },
  {
    "id": 67674590806258,
    "cents": 6570000
  },
  {
    "id": 67674590839026,
    "cents": 6575000
  },
  {
    "id": 67674590871794,
    "cents": 6580000
  },
  {
    "id": 67674590904562,
    "cents": 6585000
  },
  {
    "id": 67674590937330,
    "cents": 6590000
  },
  {
    "id": 67674590970098,
    "cents": 6595000
  },
  {
    "id": 67674591002866,
    "cents": 6600000
  },
  {
    "id": 67674591035634,
    "cents": 6605000
  },
  {
    "id": 67674591068402,
    "cents": 6610000
  },
  {
    "id": 67674591101170,
    "cents": 6615000
  },
  {
    "id": 67674591133938,
    "cents": 6620000
  },
  {
    "id": 67674591166706,
    "cents": 6625000
  },
  {
    "id": 67674591199474,
    "cents": 6630000
  },
  {
    "id": 67674591232242,
    "cents": 6635000
  },
  {
    "id": 67674591265010,
    "cents": 6640000
  },
  {
    "id": 67674591297778,
    "cents": 6645000
  },
  {
    "id": 67674591330546,
    "cents": 6650000
  },
  {
    "id": 67674591363314,
    "cents": 6655000
  },
  {
    "id": 67674591396082,
    "cents": 6660000
  },
  {
    "id": 67674591428850,
    "cents": 6665000
  },
  {
    "id": 67674591461618,
    "cents": 6670000
  },
  {
    "id": 67674591494386,
    "cents": 6675000
  },
  {
    "id": 67674591527154,
    "cents": 6680000
  },
  {
    "id": 67674591559922,
    "cents": 6685000
  },
  {
    "id": 67674591592690,
    "cents": 6690000
  },
  {
    "id": 67674591625458,
    "cents": 6695000
  },
  {
    "id": 67674591658226,
    "cents": 6700000
  },
  {
    "id": 67674591690994,
    "cents": 6705000
  },
  {
    "id": 67674591723762,
    "cents": 6710000
  },
  {
    "id": 67674591756530,
    "cents": 6715000
  },
  {
    "id": 67674591789298,
    "cents": 6720000
  },
  {
    "id": 67674591822066,
    "cents": 6725000
  },
  {
    "id": 67674591854834,
    "cents": 6730000
  },
  {
    "id": 67674591887602,
    "cents": 6735000
  },
  {
    "id": 67674591920370,
    "cents": 6740000
  },
  {
    "id": 67674591953138,
    "cents": 6745000
  },
  {
    "id": 67674591985906,
    "cents": 6750000
  },
  {
    "id": 67674592018674,
    "cents": 6755000
  },
  {
    "id": 67674592051442,
    "cents": 6760000
  },
  {
    "id": 67674592084210,
    "cents": 6765000
  },
  {
    "id": 67674592116978,
    "cents": 6770000
  },
  {
    "id": 67674592149746,
    "cents": 6775000
  },
  {
    "id": 67674592182514,
    "cents": 6780000
  },
  {
    "id": 67674592215282,
    "cents": 6785000
  },
  {
    "id": 67674592248050,
    "cents": 6790000
  },
  {
    "id": 67674592280818,
    "cents": 6795000
  },
  {
    "id": 67674592313586,
    "cents": 6800000
  },
  {
    "id": 67674592346354,
    "cents": 6805000
  },
  {
    "id": 67674592379122,
    "cents": 6810000
  },
  {
    "id": 67674592411890,
    "cents": 6815000
  },
  {
    "id": 67674592444658,
    "cents": 6820000
  },
  {
    "id": 67674592477426,
    "cents": 6825000
  },
  {
    "id": 67674592510194,
    "cents": 6830000
  },
  {
    "id": 67674592542962,
    "cents": 6835000
  },
  {
    "id": 67674592575730,
    "cents": 6840000
  },
  {
    "id": 67674592608498,
    "cents": 6845000
  },
  {
    "id": 67674592641266,
    "cents": 6850000
  },
  {
    "id": 67674592674034,
    "cents": 6855000
  },
  {
    "id": 67674592706802,
    "cents": 6860000
  },
  {
    "id": 67674592739570,
    "cents": 6865000
  },
  {
    "id": 67674592772338,
    "cents": 6870000
  },
  {
    "id": 67674592805106,
    "cents": 6875000
  },
  {
    "id": 67674592837874,
    "cents": 6880000
  },
  {
    "id": 67674592870642,
    "cents": 6885000
  },
  {
    "id": 67674592903410,
    "cents": 6890000
  },
  {
    "id": 67674592936178,
    "cents": 6895000
  },
  {
    "id": 67674592968946,
    "cents": 6900000
  },
  {
    "id": 67674593001714,
    "cents": 6905000
  },
  {
    "id": 67674593034482,
    "cents": 6910000
  },
  {
    "id": 67674593067250,
    "cents": 6915000
  },
  {
    "id": 67674593100018,
    "cents": 6920000
  },
  {
    "id": 67674593132786,
    "cents": 6925000
  },
  {
    "id": 67674593165554,
    "cents": 6930000
  },
  {
    "id": 67674593198322,
    "cents": 6935000
  },
  {
    "id": 67674593231090,
    "cents": 6940000
  },
  {
    "id": 67674593263858,
    "cents": 6945000
  },
  {
    "id": 67674593296626,
    "cents": 6950000
  },
  {
    "id": 67674593329394,
    "cents": 6955000
  },
  {
    "id": 67674593362162,
    "cents": 6960000
  },
  {
    "id": 67674593394930,
    "cents": 6965000
  },
  {
    "id": 67674593427698,
    "cents": 6970000
  },
  {
    "id": 67674593460466,
    "cents": 6975000
  },
  {
    "id": 67674593493234,
    "cents": 6980000
  },
  {
    "id": 67674593526002,
    "cents": 6985000
  },
  {
    "id": 67674593558770,
    "cents": 6990000
  },
  {
    "id": 67674593591538,
    "cents": 6995000
  },
  {
    "id": 67674593624306,
    "cents": 7000000
  },
  {
    "id": 67674593657074,
    "cents": 7005000
  },
  {
    "id": 67674593689842,
    "cents": 7010000
  },
  {
    "id": 67674593722610,
    "cents": 7015000
  },
  {
    "id": 67674593755378,
    "cents": 7020000
  },
  {
    "id": 67674593788146,
    "cents": 7025000
  },
  {
    "id": 67674593820914,
    "cents": 7030000
  },
  {
    "id": 67674593853682,
    "cents": 7035000
  },
  {
    "id": 67674593886450,
    "cents": 7040000
  },
  {
    "id": 67674593919218,
    "cents": 7045000
  },
  {
    "id": 67674593951986,
    "cents": 7050000
  },
  {
    "id": 67674593984754,
    "cents": 7055000
  },
  {
    "id": 67674594017522,
    "cents": 7060000
  },
  {
    "id": 67674594050290,
    "cents": 7065000
  },
  {
    "id": 67674594083058,
    "cents": 7070000
  },
  {
    "id": 67674594115826,
    "cents": 7075000
  },
  {
    "id": 67674594148594,
    "cents": 7080000
  },
  {
    "id": 67674594181362,
    "cents": 7085000
  },
  {
    "id": 67674594214130,
    "cents": 7090000
  },
  {
    "id": 67674594246898,
    "cents": 7095000
  },
  {
    "id": 67674594279666,
    "cents": 7100000
  },
  {
    "id": 67674594312434,
    "cents": 7105000
  },
  {
    "id": 67674594345202,
    "cents": 7110000
  },
  {
    "id": 67674594377970,
    "cents": 7115000
  },
  {
    "id": 67674594410738,
    "cents": 7120000
  },
  {
    "id": 67674594443506,
    "cents": 7125000
  },
  {
    "id": 67674594476274,
    "cents": 7130000
  },
  {
    "id": 67674594509042,
    "cents": 7135000
  },
  {
    "id": 67674594541810,
    "cents": 7140000
  },
  {
    "id": 67674594574578,
    "cents": 7145000
  },
  {
    "id": 67674594607346,
    "cents": 7150000
  },
  {
    "id": 67674594640114,
    "cents": 7155000
  },
  {
    "id": 67674594672882,
    "cents": 7160000
  },
  {
    "id": 67674594705650,
    "cents": 7165000
  },
  {
    "id": 67674594738418,
    "cents": 7170000
  },
  {
    "id": 67674594771186,
    "cents": 7175000
  },
  {
    "id": 67674594803954,
    "cents": 7180000
  },
  {
    "id": 67674594836722,
    "cents": 7185000
  },
  {
    "id": 67674594869490,
    "cents": 7190000
  },
  {
    "id": 67674594902258,
    "cents": 7195000
  },
  {
    "id": 67674594935026,
    "cents": 7200000
  },
  {
    "id": 67674594967794,
    "cents": 7205000
  },
  {
    "id": 67674595000562,
    "cents": 7210000
  },
  {
    "id": 67674595033330,
    "cents": 7215000
  },
  {
    "id": 67674595066098,
    "cents": 7220000
  },
  {
    "id": 67674595098866,
    "cents": 7225000
  },
  {
    "id": 67674595131634,
    "cents": 7230000
  },
  {
    "id": 67674595164402,
    "cents": 7235000
  },
  {
    "id": 67674595197170,
    "cents": 7240000
  },
  {
    "id": 67674595229938,
    "cents": 7245000
  },
  {
    "id": 67674595262706,
    "cents": 7250000
  },
  {
    "id": 67674595295474,
    "cents": 7255000
  },
  {
    "id": 67674595328242,
    "cents": 7260000
  },
  {
    "id": 67674595361010,
    "cents": 7265000
  },
  {
    "id": 67674595393778,
    "cents": 7270000
  },
  {
    "id": 67674595426546,
    "cents": 7275000
  },
  {
    "id": 67674595459314,
    "cents": 7280000
  },
  {
    "id": 67674595492082,
    "cents": 7285000
  },
  {
    "id": 67674595524850,
    "cents": 7290000
  },
  {
    "id": 67674595557618,
    "cents": 7295000
  },
  {
    "id": 67674595590386,
    "cents": 7300000
  },
  {
    "id": 67674595623154,
    "cents": 7305000
  },
  {
    "id": 67674595655922,
    "cents": 7310000
  },
  {
    "id": 67674595688690,
    "cents": 7315000
  },
  {
    "id": 67674595721458,
    "cents": 7320000
  },
  {
    "id": 67674595754226,
    "cents": 7325000
  },
  {
    "id": 67674595786994,
    "cents": 7330000
  },
  {
    "id": 67674595819762,
    "cents": 7335000
  },
  {
    "id": 67674595852530,
    "cents": 7340000
  },
  {
    "id": 67674595885298,
    "cents": 7345000
  },
  {
    "id": 67674595918066,
    "cents": 7350000
  },
  {
    "id": 67674595950834,
    "cents": 7355000
  },
  {
    "id": 67674595983602,
    "cents": 7360000
  },
  {
    "id": 67674596016370,
    "cents": 7365000
  },
  {
    "id": 67674596049138,
    "cents": 7370000
  },
  {
    "id": 67674596081906,
    "cents": 7375000
  },
  {
    "id": 67674596114674,
    "cents": 7380000
  },
  {
    "id": 67674596147442,
    "cents": 7385000
  },
  {
    "id": 67674596180210,
    "cents": 7390000
  },
  {
    "id": 67674596212978,
    "cents": 7395000
  },
  {
    "id": 67674596245746,
    "cents": 7400000
  },
  {
    "id": 67674596278514,
    "cents": 7405000
  },
  {
    "id": 67674596311282,
    "cents": 7410000
  },
  {
    "id": 67674596344050,
    "cents": 7415000
  },
  {
    "id": 67674596376818,
    "cents": 7420000
  },
  {
    "id": 67674596409586,
    "cents": 7425000
  },
  {
    "id": 67674596442354,
    "cents": 7430000
  },
  {
    "id": 67674596475122,
    "cents": 7435000
  },
  {
    "id": 67674596507890,
    "cents": 7440000
  },
  {
    "id": 67674596540658,
    "cents": 7445000
  },
  {
    "id": 67674596573426,
    "cents": 7450000
  },
  {
    "id": 67674596606194,
    "cents": 7455000
  },
  {
    "id": 67674596638962,
    "cents": 7460000
  },
  {
    "id": 67674596671730,
    "cents": 7465000
  },
  {
    "id": 67674596704498,
    "cents": 7470000
  },
  {
    "id": 67674596737266,
    "cents": 7475000
  },
  {
    "id": 67674596770034,
    "cents": 7480000
  },
  {
    "id": 67674596802802,
    "cents": 7485000
  },
  {
    "id": 67674596835570,
    "cents": 7490000
  },
  {
    "id": 67674596868338,
    "cents": 7495000
  },
  {
    "id": 67674596901106,
    "cents": 7500000
  },
  {
    "id": 67674596933874,
    "cents": 7505000
  },
  {
    "id": 67674596966642,
    "cents": 7510000
  },
  {
    "id": 67674596999410,
    "cents": 7515000
  },
  {
    "id": 67674597032178,
    "cents": 7520000
  },
  {
    "id": 67674597064946,
    "cents": 7525000
  },
  {
    "id": 67674597097714,
    "cents": 7530000
  },
  {
    "id": 67674597130482,
    "cents": 7535000
  },
  {
    "id": 67674597163250,
    "cents": 7540000
  },
  {
    "id": 67674597196018,
    "cents": 7545000
  },
  {
    "id": 67674597228786,
    "cents": 7550000
  },
  {
    "id": 67674597261554,
    "cents": 7555000
  },
  {
    "id": 67674597294322,
    "cents": 7560000
  },
  {
    "id": 67674597327090,
    "cents": 7565000
  },
  {
    "id": 67674597359858,
    "cents": 7570000
  },
  {
    "id": 67674597392626,
    "cents": 7575000
  },
  {
    "id": 67674597425394,
    "cents": 7580000
  },
  {
    "id": 67674597458162,
    "cents": 7585000
  },
  {
    "id": 67674597490930,
    "cents": 7590000
  },
  {
    "id": 67674597523698,
    "cents": 7595000
  },
  {
    "id": 67674597556466,
    "cents": 7600000
  },
  {
    "id": 67674597589234,
    "cents": 7605000
  },
  {
    "id": 67674597622002,
    "cents": 7610000
  },
  {
    "id": 67674597654770,
    "cents": 7615000
  },
  {
    "id": 67674597687538,
    "cents": 7620000
  },
  {
    "id": 67674597720306,
    "cents": 7625000
  },
  {
    "id": 67674597753074,
    "cents": 7630000
  },
  {
    "id": 67674597785842,
    "cents": 7635000
  },
  {
    "id": 67674597818610,
    "cents": 7640000
  },
  {
    "id": 67674597851378,
    "cents": 7645000
  },
  {
    "id": 67674597884146,
    "cents": 7650000
  },
  {
    "id": 67674597916914,
    "cents": 7655000
  },
  {
    "id": 67674597949682,
    "cents": 7660000
  },
  {
    "id": 67674597982450,
    "cents": 7665000
  },
  {
    "id": 67674598015218,
    "cents": 7670000
  },
  {
    "id": 67674598047986,
    "cents": 7675000
  },
  {
    "id": 67674598080754,
    "cents": 7680000
  },
  {
    "id": 67674598113522,
    "cents": 7685000
  },
  {
    "id": 67674598146290,
    "cents": 7690000
  },
  {
    "id": 67674598179058,
    "cents": 7695000
  },
  {
    "id": 67674598211826,
    "cents": 7700000
  },
  {
    "id": 67674598244594,
    "cents": 7705000
  },
  {
    "id": 67674598277362,
    "cents": 7710000
  },
  {
    "id": 67674598310130,
    "cents": 7715000
  },
  {
    "id": 67674598342898,
    "cents": 7720000
  },
  {
    "id": 67674598375666,
    "cents": 7725000
  },
  {
    "id": 67674598408434,
    "cents": 7730000
  },
  {
    "id": 67674598441202,
    "cents": 7735000
  },
  {
    "id": 67674598473970,
    "cents": 7740000
  },
  {
    "id": 67674598506738,
    "cents": 7745000
  },
  {
    "id": 67674598539506,
    "cents": 7750000
  },
  {
    "id": 67674598572274,
    "cents": 7755000
  },
  {
    "id": 67674598605042,
    "cents": 7760000
  },
  {
    "id": 67674598637810,
    "cents": 7765000
  },
  {
    "id": 67674598670578,
    "cents": 7770000
  },
  {
    "id": 67674598703346,
    "cents": 7775000
  },
  {
    "id": 67674598736114,
    "cents": 7780000
  },
  {
    "id": 67674598768882,
    "cents": 7785000
  },
  {
    "id": 67674598801650,
    "cents": 7790000
  },
  {
    "id": 67674598834418,
    "cents": 7795000
  },
  {
    "id": 67674598867186,
    "cents": 7800000
  },
  {
    "id": 67674598899954,
    "cents": 7805000
  },
  {
    "id": 67674598932722,
    "cents": 7810000
  },
  {
    "id": 67674598965490,
    "cents": 7815000
  },
  {
    "id": 67674598998258,
    "cents": 7820000
  },
  {
    "id": 67674599031026,
    "cents": 7825000
  },
  {
    "id": 67674599063794,
    "cents": 7830000
  },
  {
    "id": 67674599096562,
    "cents": 7835000
  },
  {
    "id": 67674599129330,
    "cents": 7840000
  },
  {
    "id": 67674599162098,
    "cents": 7845000
  },
  {
    "id": 67674599194866,
    "cents": 7850000
  },
  {
    "id": 67674599227634,
    "cents": 7855000
  },
  {
    "id": 67674599260402,
    "cents": 7860000
  },
  {
    "id": 67674599293170,
    "cents": 7865000
  },
  {
    "id": 67674599325938,
    "cents": 7870000
  },
  {
    "id": 67674599358706,
    "cents": 7875000
  },
  {
    "id": 67674599391474,
    "cents": 7880000
  },
  {
    "id": 67674599424242,
    "cents": 7885000
  },
  {
    "id": 67674599457010,
    "cents": 7890000
  },
  {
    "id": 67674599489778,
    "cents": 7895000
  },
  {
    "id": 67674599522546,
    "cents": 7900000
  },
  {
    "id": 67674599555314,
    "cents": 7905000
  },
  {
    "id": 67674599588082,
    "cents": 7910000
  },
  {
    "id": 67674599620850,
    "cents": 7915000
  },
  {
    "id": 67674599653618,
    "cents": 7920000
  },
  {
    "id": 67674599686386,
    "cents": 7925000
  },
  {
    "id": 67674599719154,
    "cents": 7930000
  },
  {
    "id": 67674599751922,
    "cents": 7935000
  },
  {
    "id": 67674599784690,
    "cents": 7940000
  },
  {
    "id": 67674599817458,
    "cents": 7945000
  },
  {
    "id": 67674599850226,
    "cents": 7950000
  },
  {
    "id": 67674599882994,
    "cents": 7955000
  },
  {
    "id": 67674599915762,
    "cents": 7960000
  },
  {
    "id": 67674599948530,
    "cents": 7965000
  },
  {
    "id": 67674599981298,
    "cents": 7970000
  },
  {
    "id": 67674600014066,
    "cents": 7975000
  },
  {
    "id": 67674600046834,
    "cents": 7980000
  },
  {
    "id": 67674600079602,
    "cents": 7985000
  },
  {
    "id": 67674600112370,
    "cents": 7990000
  },
  {
    "id": 67674600145138,
    "cents": 7995000
  },
  {
    "id": 67674600177906,
    "cents": 8000000
  },
  {
    "id": 67674600210674,
    "cents": 8005000
  },
  {
    "id": 67674600243442,
    "cents": 8010000
  },
  {
    "id": 67674600276210,
    "cents": 8015000
  },
  {
    "id": 67674600374514,
    "cents": 8020000
  },
  {
    "id": 67674600407282,
    "cents": 8025000
  },
  {
    "id": 67674600440050,
    "cents": 8030000
  },
  {
    "id": 67674600472818,
    "cents": 8035000
  },
  {
    "id": 67674600505586,
    "cents": 8040000
  },
  {
    "id": 67674600538354,
    "cents": 8045000
  },
  {
    "id": 67674600571122,
    "cents": 8050000
  },
  {
    "id": 67674600603890,
    "cents": 8055000
  },
  {
    "id": 67674600636658,
    "cents": 8060000
  },
  {
    "id": 67674600669426,
    "cents": 8065000
  },
  {
    "id": 67674600702194,
    "cents": 8070000
  },
  {
    "id": 67674600734962,
    "cents": 8075000
  },
  {
    "id": 67674600767730,
    "cents": 8080000
  },
  {
    "id": 67674600800498,
    "cents": 8085000
  },
  {
    "id": 67674600833266,
    "cents": 8090000
  },
  {
    "id": 67674600866034,
    "cents": 8095000
  },
  {
    "id": 67674600898802,
    "cents": 8100000
  },
  {
    "id": 67674600931570,
    "cents": 8105000
  },
  {
    "id": 67674600964338,
    "cents": 8110000
  },
  {
    "id": 67674600997106,
    "cents": 8115000
  },
  {
    "id": 67674601029874,
    "cents": 8120000
  },
  {
    "id": 67674601062642,
    "cents": 8125000
  },
  {
    "id": 67674601095410,
    "cents": 8130000
  },
  {
    "id": 67674601128178,
    "cents": 8135000
  },
  {
    "id": 67674601160946,
    "cents": 8140000
  },
  {
    "id": 67674601193714,
    "cents": 8145000
  },
  {
    "id": 67674601226482,
    "cents": 8150000
  },
  {
    "id": 67674601259250,
    "cents": 8155000
  },
  {
    "id": 67674601292018,
    "cents": 8160000
  },
  {
    "id": 67674601324786,
    "cents": 8165000
  },
  {
    "id": 67674601357554,
    "cents": 8170000
  },
  {
    "id": 67674601390322,
    "cents": 8175000
  },
  {
    "id": 67674601423090,
    "cents": 8180000
  },
  {
    "id": 67674601455858,
    "cents": 8185000
  },
  {
    "id": 67674601488626,
    "cents": 8190000
  },
  {
    "id": 67674601521394,
    "cents": 8195000
  },
  {
    "id": 67674601554162,
    "cents": 8200000
  },
  {
    "id": 67674601586930,
    "cents": 8205000
  },
  {
    "id": 67674601619698,
    "cents": 8210000
  },
  {
    "id": 67674601652466,
    "cents": 8215000
  },
  {
    "id": 67674601685234,
    "cents": 8220000
  },
  {
    "id": 67674601718002,
    "cents": 8225000
  },
  {
    "id": 67674601750770,
    "cents": 8230000
  },
  {
    "id": 67674601783538,
    "cents": 8235000
  },
  {
    "id": 67674601816306,
    "cents": 8240000
  },
  {
    "id": 67674601849074,
    "cents": 8245000
  },
  {
    "id": 67674601881842,
    "cents": 8250000
  },
  {
    "id": 67674601914610,
    "cents": 8255000
  },
  {
    "id": 67674601947378,
    "cents": 8260000
  },
  {
    "id": 67674601980146,
    "cents": 8265000
  },
  {
    "id": 67674602012914,
    "cents": 8270000
  },
  {
    "id": 67674602045682,
    "cents": 8275000
  },
  {
    "id": 67674602078450,
    "cents": 8280000
  },
  {
    "id": 67674602111218,
    "cents": 8285000
  },
  {
    "id": 67674602143986,
    "cents": 8290000
  },
  {
    "id": 67674602176754,
    "cents": 8295000
  },
  {
    "id": 67674602209522,
    "cents": 8300000
  },
  {
    "id": 67674602242290,
    "cents": 8305000
  },
  {
    "id": 67674602275058,
    "cents": 8310000
  },
  {
    "id": 67674602307826,
    "cents": 8315000
  },
  {
    "id": 67674602340594,
    "cents": 8320000
  },
  {
    "id": 67674602373362,
    "cents": 8325000
  },
  {
    "id": 67674602406130,
    "cents": 8330000
  },
  {
    "id": 67674602438898,
    "cents": 8335000
  },
  {
    "id": 67674602471666,
    "cents": 8340000
  },
  {
    "id": 67674602504434,
    "cents": 8345000
  },
  {
    "id": 67674602537202,
    "cents": 8350000
  },
  {
    "id": 67674602569970,
    "cents": 8355000
  },
  {
    "id": 67674602602738,
    "cents": 8360000
  },
  {
    "id": 67674602635506,
    "cents": 8365000
  },
  {
    "id": 67674602668274,
    "cents": 8370000
  },
  {
    "id": 67674602701042,
    "cents": 8375000
  },
  {
    "id": 67674602733810,
    "cents": 8380000
  },
  {
    "id": 67674602766578,
    "cents": 8385000
  },
  {
    "id": 67674602799346,
    "cents": 8390000
  },
  {
    "id": 67674602832114,
    "cents": 8395000
  },
  {
    "id": 67674602864882,
    "cents": 8400000
  },
  {
    "id": 67674602897650,
    "cents": 8405000
  },
  {
    "id": 67674602930418,
    "cents": 8410000
  },
  {
    "id": 67674602963186,
    "cents": 8415000
  },
  {
    "id": 67674602995954,
    "cents": 8420000
  },
  {
    "id": 67674603028722,
    "cents": 8425000
  },
  {
    "id": 67674603061490,
    "cents": 8430000
  },
  {
    "id": 67674603094258,
    "cents": 8435000
  },
  {
    "id": 67674603127026,
    "cents": 8440000
  },
  {
    "id": 67674603159794,
    "cents": 8445000
  },
  {
    "id": 67674603192562,
    "cents": 8450000
  },
  {
    "id": 67674603225330,
    "cents": 8455000
  },
  {
    "id": 67674603258098,
    "cents": 8460000
  },
  {
    "id": 67674603290866,
    "cents": 8465000
  },
  {
    "id": 67674603323634,
    "cents": 8470000
  },
  {
    "id": 67674603356402,
    "cents": 8475000
  },
  {
    "id": 67674603389170,
    "cents": 8480000
  },
  {
    "id": 67674603421938,
    "cents": 8485000
  },
  {
    "id": 67674603454706,
    "cents": 8490000
  },
  {
    "id": 67674603487474,
    "cents": 8495000
  },
  {
    "id": 67674603520242,
    "cents": 8500000
  },
  {
    "id": 67674603553010,
    "cents": 8505000
  },
  {
    "id": 67674603585778,
    "cents": 8510000
  },
  {
    "id": 67674603618546,
    "cents": 8515000
  },
  {
    "id": 67674603651314,
    "cents": 8520000
  },
  {
    "id": 67674603684082,
    "cents": 8525000
  },
  {
    "id": 67674603716850,
    "cents": 8530000
  },
  {
    "id": 67674603749618,
    "cents": 8535000
  },
  {
    "id": 67674603782386,
    "cents": 8540000
  },
  {
    "id": 67674603815154,
    "cents": 8545000
  },
  {
    "id": 67674603847922,
    "cents": 8550000
  },
  {
    "id": 67674603880690,
    "cents": 8555000
  },
  {
    "id": 67674603913458,
    "cents": 8560000
  },
  {
    "id": 67674603946226,
    "cents": 8565000
  },
  {
    "id": 67674603978994,
    "cents": 8570000
  },
  {
    "id": 67674604011762,
    "cents": 8575000
  },
  {
    "id": 67674604044530,
    "cents": 8580000
  },
  {
    "id": 67674604077298,
    "cents": 8585000
  },
  {
    "id": 67674604110066,
    "cents": 8590000
  },
  {
    "id": 67674604142834,
    "cents": 8595000
  },
  {
    "id": 67674604175602,
    "cents": 8600000
  },
  {
    "id": 67674604208370,
    "cents": 8605000
  },
  {
    "id": 67674604241138,
    "cents": 8610000
  },
  {
    "id": 67674604273906,
    "cents": 8615000
  },
  {
    "id": 67674604306674,
    "cents": 8620000
  },
  {
    "id": 67674604339442,
    "cents": 8625000
  },
  {
    "id": 67674604372210,
    "cents": 8630000
  },
  {
    "id": 67674604404978,
    "cents": 8635000
  },
  {
    "id": 67674604437746,
    "cents": 8640000
  },
  {
    "id": 67674604470514,
    "cents": 8645000
  },
  {
    "id": 67674604503282,
    "cents": 8650000
  },
  {
    "id": 67674604536050,
    "cents": 8655000
  },
  {
    "id": 67674604568818,
    "cents": 8660000
  },
  {
    "id": 67674604601586,
    "cents": 8665000
  },
  {
    "id": 67674604634354,
    "cents": 8670000
  },
  {
    "id": 67674604667122,
    "cents": 8675000
  },
  {
    "id": 67674604699890,
    "cents": 8680000
  },
  {
    "id": 67674604732658,
    "cents": 8685000
  },
  {
    "id": 67674604765426,
    "cents": 8690000
  },
  {
    "id": 67674604798194,
    "cents": 8695000
  },
  {
    "id": 67674604830962,
    "cents": 8700000
  },
  {
    "id": 67674604863730,
    "cents": 8705000
  },
  {
    "id": 67674604896498,
    "cents": 8710000
  },
  {
    "id": 67674604929266,
    "cents": 8715000
  },
  {
    "id": 67674604962034,
    "cents": 8720000
  },
  {
    "id": 67674604994802,
    "cents": 8725000
  },
  {
    "id": 67674605027570,
    "cents": 8730000
  },
  {
    "id": 67674605060338,
    "cents": 8735000
  },
  {
    "id": 67674605093106,
    "cents": 8740000
  },
  {
    "id": 67674605125874,
    "cents": 8745000
  },
  {
    "id": 67674605158642,
    "cents": 8750000
  },
  {
    "id": 67674605191410,
    "cents": 8755000
  },
  {
    "id": 67674605224178,
    "cents": 8760000
  },
  {
    "id": 67674605256946,
    "cents": 8765000
  },
  {
    "id": 67674605289714,
    "cents": 8770000
  },
  {
    "id": 67674605322482,
    "cents": 8775000
  },
  {
    "id": 67674605355250,
    "cents": 8780000
  },
  {
    "id": 67674605388018,
    "cents": 8785000
  },
  {
    "id": 67674605420786,
    "cents": 8790000
  },
  {
    "id": 67674605453554,
    "cents": 8795000
  },
  {
    "id": 67674605486322,
    "cents": 8800000
  },
  {
    "id": 67674605519090,
    "cents": 8805000
  },
  {
    "id": 67674605551858,
    "cents": 8810000
  },
  {
    "id": 67674605584626,
    "cents": 8815000
  },
  {
    "id": 67674605617394,
    "cents": 8820000
  },
  {
    "id": 67674605650162,
    "cents": 8825000
  },
  {
    "id": 67674605682930,
    "cents": 8830000
  },
  {
    "id": 67674605715698,
    "cents": 8835000
  },
  {
    "id": 67674605748466,
    "cents": 8840000
  },
  {
    "id": 67674605781234,
    "cents": 8845000
  },
  {
    "id": 67674605814002,
    "cents": 8850000
  },
  {
    "id": 67674605846770,
    "cents": 8855000
  },
  {
    "id": 67674605879538,
    "cents": 8860000
  },
  {
    "id": 67674605912306,
    "cents": 8865000
  },
  {
    "id": 67674605945074,
    "cents": 8870000
  },
  {
    "id": 67674605977842,
    "cents": 8875000
  },
  {
    "id": 67674606010610,
    "cents": 8880000
  },
  {
    "id": 67674606043378,
    "cents": 8885000
  },
  {
    "id": 67674606076146,
    "cents": 8890000
  },
  {
    "id": 67674606108914,
    "cents": 8895000
  },
  {
    "id": 67674606141682,
    "cents": 8900000
  },
  {
    "id": 67674606174450,
    "cents": 8905000
  },
  {
    "id": 67674606207218,
    "cents": 8910000
  },
  {
    "id": 67674606239986,
    "cents": 8915000
  },
  {
    "id": 67674606272754,
    "cents": 8920000
  },
  {
    "id": 67674606305522,
    "cents": 8925000
  },
  {
    "id": 67674606338290,
    "cents": 8930000
  },
  {
    "id": 67674606371058,
    "cents": 8935000
  },
  {
    "id": 67674606403826,
    "cents": 8940000
  },
  {
    "id": 67674606436594,
    "cents": 8945000
  },
  {
    "id": 67674606469362,
    "cents": 8950000
  },
  {
    "id": 67674606502130,
    "cents": 8955000
  },
  {
    "id": 67674606534898,
    "cents": 8960000
  },
  {
    "id": 67674606567666,
    "cents": 8965000
  },
  {
    "id": 67674606600434,
    "cents": 8970000
  },
  {
    "id": 67674606633202,
    "cents": 8975000
  },
  {
    "id": 67674606665970,
    "cents": 8980000
  },
  {
    "id": 67674606698738,
    "cents": 8985000
  },
  {
    "id": 67674606731506,
    "cents": 8990000
  },
  {
    "id": 67674606764274,
    "cents": 8995000
  },
  {
    "id": 67674606797042,
    "cents": 9000000
  },
  {
    "id": 67674606829810,
    "cents": 9005000
  },
  {
    "id": 67674606862578,
    "cents": 9010000
  },
  {
    "id": 67674606895346,
    "cents": 9015000
  },
  {
    "id": 67674607124722,
    "cents": 9020000
  },
  {
    "id": 67674607157490,
    "cents": 9025000
  },
  {
    "id": 67674607190258,
    "cents": 9030000
  },
  {
    "id": 67674607223026,
    "cents": 9035000
  },
  {
    "id": 67674607255794,
    "cents": 9040000
  },
  {
    "id": 67674607288562,
    "cents": 9045000
  },
  {
    "id": 67674607321330,
    "cents": 9050000
  },
  {
    "id": 67674607354098,
    "cents": 9055000
  },
  {
    "id": 67674607386866,
    "cents": 9060000
  },
  {
    "id": 67674607419634,
    "cents": 9065000
  },
  {
    "id": 67674607452402,
    "cents": 9070000
  },
  {
    "id": 67674607485170,
    "cents": 9075000
  },
  {
    "id": 67674607517938,
    "cents": 9080000
  },
  {
    "id": 67674607550706,
    "cents": 9085000
  },
  {
    "id": 67674607583474,
    "cents": 9090000
  },
  {
    "id": 67674607616242,
    "cents": 9095000
  },
  {
    "id": 67674607649010,
    "cents": 9100000
  },
  {
    "id": 67674607681778,
    "cents": 9105000
  },
  {
    "id": 67674607714546,
    "cents": 9110000
  },
  {
    "id": 67674607747314,
    "cents": 9115000
  },
  {
    "id": 67674607780082,
    "cents": 9120000
  },
  {
    "id": 67674607812850,
    "cents": 9125000
  },
  {
    "id": 67674607845618,
    "cents": 9130000
  },
  {
    "id": 67674607878386,
    "cents": 9135000
  },
  {
    "id": 67674607911154,
    "cents": 9140000
  },
  {
    "id": 67674607943922,
    "cents": 9145000
  },
  {
    "id": 67674607976690,
    "cents": 9150000
  },
  {
    "id": 67674608009458,
    "cents": 9155000
  },
  {
    "id": 67674608042226,
    "cents": 9160000
  },
  {
    "id": 67674608074994,
    "cents": 9165000
  },
  {
    "id": 67674608107762,
    "cents": 9170000
  },
  {
    "id": 67674608140530,
    "cents": 9175000
  },
  {
    "id": 67674608173298,
    "cents": 9180000
  },
  {
    "id": 67674608206066,
    "cents": 9185000
  },
  {
    "id": 67674608238834,
    "cents": 9190000
  },
  {
    "id": 67674608271602,
    "cents": 9195000
  },
  {
    "id": 67674608304370,
    "cents": 9200000
  },
  {
    "id": 67674608337138,
    "cents": 9205000
  },
  {
    "id": 67674608369906,
    "cents": 9210000
  },
  {
    "id": 67674608402674,
    "cents": 9215000
  },
  {
    "id": 67674608435442,
    "cents": 9220000
  },
  {
    "id": 67674608468210,
    "cents": 9225000
  },
  {
    "id": 67674608500978,
    "cents": 9230000
  },
  {
    "id": 67674608533746,
    "cents": 9235000
  },
  {
    "id": 67674608566514,
    "cents": 9240000
  },
  {
    "id": 67674608599282,
    "cents": 9245000
  },
  {
    "id": 67674608632050,
    "cents": 9250000
  },
  {
    "id": 67674608664818,
    "cents": 9255000
  },
  {
    "id": 67674608697586,
    "cents": 9260000
  },
  {
    "id": 67674608730354,
    "cents": 9265000
  },
  {
    "id": 67674608763122,
    "cents": 9270000
  },
  {
    "id": 67674608795890,
    "cents": 9275000
  },
  {
    "id": 67674608828658,
    "cents": 9280000
  },
  {
    "id": 67674608861426,
    "cents": 9285000
  },
  {
    "id": 67674608894194,
    "cents": 9290000
  },
  {
    "id": 67674608926962,
    "cents": 9295000
  },
  {
    "id": 67674608959730,
    "cents": 9300000
  },
  {
    "id": 67674608992498,
    "cents": 9305000
  },
  {
    "id": 67674609025266,
    "cents": 9310000
  },
  {
    "id": 67674609058034,
    "cents": 9315000
  },
  {
    "id": 67674609090802,
    "cents": 9320000
  },
  {
    "id": 67674609123570,
    "cents": 9325000
  },
  {
    "id": 67674609156338,
    "cents": 9330000
  },
  {
    "id": 67674609189106,
    "cents": 9335000
  },
  {
    "id": 67674609221874,
    "cents": 9340000
  },
  {
    "id": 67674609254642,
    "cents": 9345000
  },
  {
    "id": 67674609287410,
    "cents": 9350000
  },
  {
    "id": 67674609320178,
    "cents": 9355000
  },
  {
    "id": 67674609352946,
    "cents": 9360000
  },
  {
    "id": 67674609385714,
    "cents": 9365000
  },
  {
    "id": 67674609418482,
    "cents": 9370000
  },
  {
    "id": 67674609451250,
    "cents": 9375000
  },
  {
    "id": 67674609484018,
    "cents": 9380000
  },
  {
    "id": 67674609516786,
    "cents": 9385000
  },
  {
    "id": 67674609549554,
    "cents": 9390000
  },
  {
    "id": 67674609582322,
    "cents": 9395000
  },
  {
    "id": 67674609615090,
    "cents": 9400000
  },
  {
    "id": 67674609647858,
    "cents": 9405000
  },
  {
    "id": 67674609680626,
    "cents": 9410000
  },
  {
    "id": 67674609713394,
    "cents": 9415000
  },
  {
    "id": 67674609746162,
    "cents": 9420000
  },
  {
    "id": 67674609778930,
    "cents": 9425000
  },
  {
    "id": 67674609811698,
    "cents": 9430000
  },
  {
    "id": 67674609844466,
    "cents": 9435000
  },
  {
    "id": 67674609877234,
    "cents": 9440000
  },
  {
    "id": 67674609910002,
    "cents": 9445000
  },
  {
    "id": 67674609942770,
    "cents": 9450000
  },
  {
    "id": 67674609975538,
    "cents": 9455000
  },
  {
    "id": 67674610008306,
    "cents": 9460000
  },
  {
    "id": 67674610041074,
    "cents": 9465000
  },
  {
    "id": 67674610073842,
    "cents": 9470000
  },
  {
    "id": 67674610106610,
    "cents": 9475000
  },
  {
    "id": 67674610139378,
    "cents": 9480000
  },
  {
    "id": 67674610172146,
    "cents": 9485000
  },
  {
    "id": 67674610204914,
    "cents": 9490000
  },
  {
    "id": 67674610237682,
    "cents": 9495000
  },
  {
    "id": 67674610270450,
    "cents": 9500000
  },
  {
    "id": 67674610303218,
    "cents": 9505000
  },
  {
    "id": 67674610335986,
    "cents": 9510000
  },
  {
    "id": 67674610368754,
    "cents": 9515000
  },
  {
    "id": 67674610401522,
    "cents": 9520000
  },
  {
    "id": 67674610434290,
    "cents": 9525000
  },
  {
    "id": 67674610467058,
    "cents": 9530000
  },
  {
    "id": 67674610499826,
    "cents": 9535000
  },
  {
    "id": 67674610532594,
    "cents": 9540000
  },
  {
    "id": 67674610565362,
    "cents": 9545000
  },
  {
    "id": 67674610598130,
    "cents": 9550000
  },
  {
    "id": 67674610630898,
    "cents": 9555000
  },
  {
    "id": 67674610663666,
    "cents": 9560000
  },
  {
    "id": 67674610696434,
    "cents": 9565000
  },
  {
    "id": 67674610729202,
    "cents": 9570000
  },
  {
    "id": 67674610761970,
    "cents": 9575000
  },
  {
    "id": 67674610794738,
    "cents": 9580000
  },
  {
    "id": 67674610827506,
    "cents": 9585000
  },
  {
    "id": 67674610860274,
    "cents": 9590000
  },
  {
    "id": 67674610893042,
    "cents": 9595000
  },
  {
    "id": 67674610925810,
    "cents": 9600000
  },
  {
    "id": 67674610958578,
    "cents": 9605000
  },
  {
    "id": 67674610991346,
    "cents": 9610000
  },
  {
    "id": 67674611024114,
    "cents": 9615000
  },
  {
    "id": 67674611056882,
    "cents": 9620000
  },
  {
    "id": 67674611089650,
    "cents": 9625000
  },
  {
    "id": 67674611122418,
    "cents": 9630000
  },
  {
    "id": 67674611155186,
    "cents": 9635000
  },
  {
    "id": 67674611187954,
    "cents": 9640000
  },
  {
    "id": 67674611220722,
    "cents": 9645000
  },
  {
    "id": 67674611253490,
    "cents": 9650000
  },
  {
    "id": 67674611286258,
    "cents": 9655000
  },
  {
    "id": 67674611319026,
    "cents": 9660000
  },
  {
    "id": 67674611351794,
    "cents": 9665000
  },
  {
    "id": 67674611384562,
    "cents": 9670000
  },
  {
    "id": 67674611417330,
    "cents": 9675000
  },
  {
    "id": 67674611450098,
    "cents": 9680000
  },
  {
    "id": 67674611482866,
    "cents": 9685000
  },
  {
    "id": 67674611515634,
    "cents": 9690000
  },
  {
    "id": 67674611548402,
    "cents": 9695000
  },
  {
    "id": 67674611581170,
    "cents": 9700000
  },
  {
    "id": 67674611613938,
    "cents": 9705000
  },
  {
    "id": 67674611646706,
    "cents": 9710000
  },
  {
    "id": 67674611679474,
    "cents": 9715000
  },
  {
    "id": 67674611712242,
    "cents": 9720000
  },
  {
    "id": 67674611745010,
    "cents": 9725000
  },
  {
    "id": 67674611777778,
    "cents": 9730000
  },
  {
    "id": 67674611810546,
    "cents": 9735000
  },
  {
    "id": 67674611843314,
    "cents": 9740000
  },
  {
    "id": 67674611876082,
    "cents": 9745000
  },
  {
    "id": 67674611908850,
    "cents": 9750000
  },
  {
    "id": 67674611941618,
    "cents": 9755000
  },
  {
    "id": 67674611974386,
    "cents": 9760000
  },
  {
    "id": 67674612007154,
    "cents": 9765000
  },
  {
    "id": 67674612039922,
    "cents": 9770000
  },
  {
    "id": 67674612072690,
    "cents": 9775000
  },
  {
    "id": 67674612105458,
    "cents": 9780000
  },
  {
    "id": 67674612138226,
    "cents": 9785000
  },
  {
    "id": 67674612170994,
    "cents": 9790000
  },
  {
    "id": 67674612203762,
    "cents": 9795000
  },
  {
    "id": 67674612236530,
    "cents": 9800000
  },
  {
    "id": 67674612269298,
    "cents": 9805000
  },
  {
    "id": 67674612302066,
    "cents": 9810000
  },
  {
    "id": 67674612334834,
    "cents": 9815000
  },
  {
    "id": 67674612367602,
    "cents": 9820000
  },
  {
    "id": 67674612400370,
    "cents": 9825000
  },
  {
    "id": 67674612433138,
    "cents": 9830000
  },
  {
    "id": 67674612465906,
    "cents": 9835000
  },
  {
    "id": 67674612498674,
    "cents": 9840000
  },
  {
    "id": 67674612531442,
    "cents": 9845000
  },
  {
    "id": 67674612564210,
    "cents": 9850000
  },
  {
    "id": 67674612596978,
    "cents": 9855000
  },
  {
    "id": 67674612629746,
    "cents": 9860000
  },
  {
    "id": 67674612662514,
    "cents": 9865000
  },
  {
    "id": 67674612695282,
    "cents": 9870000
  },
  {
    "id": 67674612728050,
    "cents": 9875000
  },
  {
    "id": 67674612760818,
    "cents": 9880000
  },
  {
    "id": 67674612793586,
    "cents": 9885000
  },
  {
    "id": 67674612826354,
    "cents": 9890000
  },
  {
    "id": 67674612859122,
    "cents": 9895000
  },
  {
    "id": 67674612891890,
    "cents": 9900000
  },
  {
    "id": 67674612924658,
    "cents": 9905000
  },
  {
    "id": 67674612957426,
    "cents": 9910000
  },
  {
    "id": 67674612990194,
    "cents": 9915000
  },
  {
    "id": 67674613022962,
    "cents": 9920000
  },
  {
    "id": 67674613055730,
    "cents": 9925000
  },
  {
    "id": 67674613088498,
    "cents": 9930000
  },
  {
    "id": 67674613121266,
    "cents": 9935000
  },
  {
    "id": 67674613154034,
    "cents": 9940000
  },
  {
    "id": 67674613186802,
    "cents": 9945000
  },
  {
    "id": 67674613219570,
    "cents": 9950000
  },
  {
    "id": 67674613252338,
    "cents": 9955000
  },
  {
    "id": 67674613285106,
    "cents": 9960000
  },
  {
    "id": 67674613317874,
    "cents": 9965000
  },
  {
    "id": 67674613350642,
    "cents": 9970000
  },
  {
    "id": 67674613383410,
    "cents": 9975000
  },
  {
    "id": 67674613416178,
    "cents": 9980000
  },
  {
    "id": 67674613448946,
    "cents": 9985000
  },
  {
    "id": 67674613481714,
    "cents": 9990000
  },
  {
    "id": 67674613514482,
    "cents": 9995000
  },
  {
    "id": 50132195606770,
    "cents": 10000000
  }
];
  const FEE_IDS = new Set(FEE_VARIANTS.map((item) => item.id));

  const formatMoney = (cents) =>
    new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      maximumFractionDigits: 0
    }).format(cents / 100);

  const getCart = async () => {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('No se pudo leer el carrito.');
    return response.json();
  };

  const getBaseTotal = (cart) =>
    cart.items.reduce((total, item) => {
      if (FEE_IDS.has(Number(item.variant_id))) return total;
      return total + Number(item.final_line_price || item.line_price || 0);
    }, 0);

  const getFeeTotal = (cart) =>
    cart.items.reduce((total, item) => {
      if (!FEE_IDS.has(Number(item.variant_id))) return total;
      return total + Number(item.final_line_price || item.line_price || 0);
    }, 0);

  const buildFeeItems = (feeCents) => {
    if (feeCents <= 0) return [];
    const variant = FEE_VARIANTS.find((item) => item.cents === feeCents);
    if (!variant) {
      throw new Error('No existe una variante técnica para este importe de recargo.');
    }
    return [{ id: variant.id, quantity: 1 }];
  };

  const removeExistingFeeLines = async (cart) => {
    const feeLines = cart.items.filter((item) =>
      FEE_IDS.has(Number(item.variant_id))
    );

    if (feeLines.length === 0) return cart;

    for (const item of feeLines) {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || 'No se pudieron limpiar los recargos anteriores.');
      }
    }

    const cleanedCart = await getCart();
    const remainingFee = getFeeTotal(cleanedCart);

    if (remainingFee > 0) {
      const updates = {};
      cleanedCart.items.forEach((item) => {
        if (FEE_IDS.has(Number(item.variant_id))) {
          updates[String(item.variant_id)] = 0;
        }
      });

      if (Object.keys(updates).length > 0) {
        const fallback = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ updates })
        });

        if (!fallback.ok) {
          const data = await fallback.json().catch(() => ({}));
          throw new Error(data.description || 'No se pudieron limpiar los recargos anteriores.');
        }
      }
    }

    return getCart();
  };

  const desiredFee = (baseCents, rate) => {
    const rawFee = baseCents * rate;
    const STEP_CENTS = 5000;
    return Math.round(rawFee / STEP_CENTS) * STEP_CENTS;
  };

  const clearOrphanFees = async (cart) => {
    const base = getBaseTotal(cart);
    const feeTotal = getFeeTotal(cart);

    if (base !== 0 || feeTotal === 0) return false;

    await removeExistingFeeLines(cart);
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          _forma_pago: ''
        }
      })
    });

    window.location.reload();
    return true;
  };

  const updatePreview = async () => {
    try {
      const cart = await getCart();
      if (await clearOrphanFees(cart)) return;
      const base = getBaseTotal(cart);
      const transferFee = desiredFee(base, TRANSFER_RATE);
      const cardFee = desiredFee(base, CARD_RATE);
      document.querySelectorAll('[data-cb-base-total]').forEach((node) => {
        node.textContent = formatMoney(base);
      });
      document.querySelectorAll('[data-cb-transfer-fee]').forEach((node) => {
        node.textContent = formatMoney(transferFee);
      });
      document.querySelectorAll('[data-cb-transfer-total]').forEach((node) => {
        node.textContent = formatMoney(base + transferFee);
      });
      document.querySelectorAll('[data-cb-card-fee]').forEach((node) => {
        node.textContent = formatMoney(cardFee);
      });
      document.querySelectorAll('[data-cb-card-total]').forEach((node) => {
        node.textContent = formatMoney(base + cardFee);
      });
      document.querySelectorAll('.totals__total-value').forEach((node) => {
        node.textContent = formatMoney(cart.total_price);
      });
    } catch (error) {
      console.error(error);
    }
  };

  const selectedChoice = () => {
    const selected = document.querySelector('input[name="cb-payment-choice"]:checked');
    return selected ? selected.value : '';
  };

  const setBusy = (busy) => {
    document.querySelectorAll('#checkout, #CartDrawer-Checkout').forEach((button) => {
      button.disabled = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    });
  };

  const showError = (message) => {
    document.querySelectorAll('[data-cb-payment-error]').forEach((node) => {
      node.textContent = message;
      node.hidden = !message;
    });
  };

  const syncFee = async (choice) => {
    const cart = await getCart();
    const base = getBaseTotal(cart);
    let fee = 0;
    let paymentLabel = 'Efectivo';

    if (choice === 'transferencia') {
      fee = desiredFee(base, TRANSFER_RATE);
      paymentLabel = 'Transferencia +5%';
    } else if (choice === 'tarjeta') {
      fee = desiredFee(base, CARD_RATE);
      paymentLabel = 'Tarjeta +10%';
    }

    await removeExistingFeeLines(cart);

    const items = buildFeeItems(fee);
    if (items.length > 0) {
      const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!addResponse.ok) {
        const data = await addResponse.json().catch(() => ({}));
        throw new Error(data.description || 'No se pudo agregar el recargo seleccionado.');
      }
    }

    const attributeResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          _forma_pago: paymentLabel
        }
      })
    });

    if (!attributeResponse.ok) {
      const data = await attributeResponse.json().catch(() => ({}));
      throw new Error(data.description || 'No se pudo guardar la forma de pago.');
    }

    const updatedCart = await getCart();
    const actualFee = getFeeTotal(updatedCart);
    if (actualFee !== fee) {
      throw new Error('No se pudo aplicar correctamente el recargo seleccionado.');
    }
  };

  const onCheckout = async (event) => {
    const button = event.target.closest('#checkout, #CartDrawer-Checkout');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const choice = selectedChoice();
    if (!choice) {
      showError('Elegí una forma de pago antes de continuar.');
      document.querySelector('input[name="cb-payment-choice"]')?.focus();
      return;
    }

    showError('');
    setBusy(true);

    try {
      await syncFee(choice);
      window.location.assign('/checkout');
    } catch (error) {
      console.error(error);
      showError(error.message || 'No se pudo actualizar el total. Intentá nuevamente.');
      setBusy(false);
    }
  };

  const updateCheckoutLabel = (choice) => {
    document.querySelectorAll('[data-cb-checkout-label]').forEach((node) => {
      node.textContent =
        choice === 'transferencia' ? 'Continuar con transferencia' : 'Pagar pedido';
    });
  };

  const toggleTransferDetails = (choice) => {
    document.querySelectorAll('[data-cb-transfer-details]').forEach((node) => {
      node.hidden = choice !== 'transferencia';
    });
    updateCheckoutLabel(choice);
  };

  const onChoiceChange = async (event) => {
    if (!event.target.matches('input[name="cb-payment-choice"]')) return;
    const choice = event.target.value;
    showError('');
    document.querySelectorAll('input[name="cb-payment-choice"]').forEach((input) => {
      input.checked = input.value === choice;
    });
    toggleTransferDetails(choice);
    setBusy(true);

    try {
      await syncFee(choice);
      await updatePreview();
    } catch (error) {
      console.error(error);
      showError(error.message || 'No se pudo actualizar el total. Intentá nuevamente.');
    } finally {
      setBusy(false);
    }
  };

  document.addEventListener('click', onCheckout, true);
  document.addEventListener('change', onChoiceChange);
  document.addEventListener('DOMContentLoaded', () => {
    toggleTransferDetails(selectedChoice());
    updatePreview();
  });
  toggleTransferDetails(selectedChoice());
  updatePreview();
})();
